import React, { useEffect, useRef, useState, useMemo, act } from "react";
import SubHeader from "../../../components/SubHeader";
import SiteButtons from "../../../components/SiteButtons";
import { useHref, useNavigate, useParams } from "react-router-dom";
import { URLS } from "../../../_config";
import Container from "../../../components/Container";
import { Controller, set, useForm } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import CommonDropdown from "../../../components/elements/form/commonDropdown";
import Label from "../../../components/elements/form/fromLabel";
import Textarea from "../../../components/elements/form/textarea";
import { useLookup, getLookupDisplayValue } from "../../../_common/hookFunction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Icon from "../../../components/icons";
import moment from "moment";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useDiscountsApi } from "../../../store/api/hooks/discountsApiHook";
import toast from "react-hot-toast";
import TopTabs from "../../../components/topTabs";
import { useCategoriesApi } from "../../../store/api/hooks/categoriesApiHook";
import { useLocationsSelector } from "../../../store/selectors/masterSelector";
import SiteModal from "../../../components/SiteModal";
import ProductSearchModal from "../_components/ProductSearchModal";
import ProductSearchModalAll from "../_components/ProductSearchModalAll";
import Button from "../../../components/elements/button";
import ReusableTable from "../../../components/ReusableTable";
import SelectBox from "../../../components/elements/form/selectBox";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import {
  getRetailPriceInArray,
  getRetailPrices,
  getCashPriceDisplay,
  formatCurrency,
  formatQuantity,
  getPricingMode,
  CashDiscountConfig,
} from "../../../_common/functions";
import { useCashDiscountApi } from "../../../store/api/hooks/cashDiscountApiHook";
import SwitchSlider from "../../../components/elements/form/SwitchSlider";
import { useDialog } from "../../../store/api/hooks/dialogHook";
import { useBrandsApi } from "../../../store/api/hooks/brandsApiHook";
import { useTagsApi } from "../../../store/api/hooks/tagsApiHook";
import { useVendorsApi } from "../../../store/api/hooks/vendorsApiHook";
import { useUnitsApi } from "../../../store/api/hooks/unitsApiHook";
import DecimalInput from "../../../components/elements/form/DecimalInput";
import { navigationConfirm } from "../../../_common/functions";
import { useTranslation } from "react-i18next";

type formValues = {
  productCategory: any[] | string | null;
  discountId: string | null;
  fkDiscountTypeLookupValueId: string | null;
  discountName: string;
  discountDescription: string;
  isAutomatic: boolean;
  discountCode: string;
  isSetDateRange: boolean;
  isSetSchedule: boolean;
  active: boolean;
  fkCustomerTargetTypeLookupValueId: string;
  ui_maxdiscountallowed: string | null;
  discountCombination: Array<{ fkCombinationsLookupValueId: string }>;
  customerGroups: Array<{
    discountCustomerGroupId: string;
    fkCustomerGroupId: string;
    active: boolean;
  }>;
  locations: Array<{
    discountLocationId: string;
    fkLocationId: string;
    active: boolean;
  }>;
  products: Array<{
    discountProductId: string;
    fkProductId: string;
    fkProductVariantDetailId: string;
    fkProductRoleLookupValueId: string;
    requiredQuantity: string;
  }>;
  rules: Array<{
    discountRuleId: string;
    fkDiscountValueTypeLookupValueId: any | null;
    discountValue: string;
    fkMinimumRequirementTypeLookupValueId: string | null;
    minPurchaseAmount: string;
    minPurchaseQty: string;
    maxPurchaseQty: string | null;
    fkMaxLimitTypeLookupValueId: string | null;
    maxAllowedQty: string | null;
    maxAllowedValue: string | null;
    totalUsageLimit: any;
    limitToOneUsePerCustomer: boolean;
    requiredQuantity: string | null;
    active: boolean;
  }>;
  dateRanges: Array<{
    discountScheduleDateRangeId: string;
    startDate: any;
    endDate: any;
  }>;
  weeklySchedules: Array<{
    discountScheduleWeeklyId: string;
    dayOfWeek: string;
    startTime: any;
    endTime: any;
    isActive: boolean;
  }>;
};

type typeWiseFormValues = {
  SpecialPricing: formValues;
  MixAndMatch: formValues;
};

function CreateProductDiscount() {
  const { t, i18n } = useTranslation("discounts");
  const navigate = useNavigate();
  const params = useParams();
  const discountApi = useDiscountsApi();
  const cashDiscountApi = useCashDiscountApi();
  const { confirm } = useDialog();
  const [cashDiscountConfig, setCashDiscountConfig] = useState<CashDiscountConfig>(null);
  const [expandedProductsSpecialPricing, setExpandedProductsSpecialPricing] =
    useState<Set<string>>(new Set());
  const [expandedProductsMixAndMatch, setExpandedProductsMixAndMatch] =
    useState<Set<string>>(new Set());

  useEffect(() => {
    cashDiscountApi.getCashDiscountSettings(
      {},
      (resp: any) => {
        if (resp?.data) {
          setCashDiscountConfig({
            isCashDiscount: resp.data.cashDiscountEnabled,
            cashDiscount: resp.data.cashDiscountPercent,
            isDualPricing: resp.data.dualPricingEnabled ?? false,
            dualPriceDefault: resp.data.fkDualPriceDefaultLookupValueID ?? null,
          });
        }
      },
      () => {}
    );
  }, []);

  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    setFocus,
    formState: { errors },
    watch,
    trigger,
  } = useForm<typeWiseFormValues>({
    defaultValues: {
      SpecialPricing: {
        productCategory: null,
        discountId: null,
        fkDiscountTypeLookupValueId: "",
        discountName: ``,
        discountDescription: ``,
        isAutomatic: false,
        discountCode: ``,
        isSetDateRange: false,
        isSetSchedule: false,
        active: true,
        fkCustomerTargetTypeLookupValueId: btoa(`139`),
        ui_maxdiscountallowed: null,
        discountCombination: [],
        customerGroups: [],
        locations: [],
        products: [],
        rules: [
          {
            discountRuleId: ``,
            fkDiscountValueTypeLookupValueId: "NDg=",
            discountValue: `0.00`,
            fkMinimumRequirementTypeLookupValueId: null,
            minPurchaseAmount: `0`,
            minPurchaseQty: `1`,
            maxPurchaseQty: `0`,
            fkMaxLimitTypeLookupValueId: null,
            maxAllowedQty: `1`,
            maxAllowedValue: `0`,
            totalUsageLimit: `1`,
            limitToOneUsePerCustomer: false,
            requiredQuantity: `0`,
            active: true,
          },
        ],
        dateRanges: [
          { discountScheduleDateRangeId: ``, startDate: ``, endDate: `` },
        ],
        weeklySchedules: [
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `1`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `2`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `3`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `4`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `5`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `6`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `0`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
        ],
      },
      MixAndMatch: {
        productCategory: null,
        discountId: null,
        fkDiscountTypeLookupValueId: "",
        discountName: ``,
        discountDescription: ``,
        isAutomatic: false,
        discountCode: ``,
        isSetDateRange: false,
        isSetSchedule: false,
        active: true,
        fkCustomerTargetTypeLookupValueId: btoa(`139`),
        ui_maxdiscountallowed: null,
        discountCombination: [],
        customerGroups: [],
        locations: [],
        products: [],
        rules: [
          {
            discountRuleId: ``,
            fkDiscountValueTypeLookupValueId: "NDg=",
            discountValue: `0.00`,
            fkMinimumRequirementTypeLookupValueId: null,
            minPurchaseAmount: `0`,
            minPurchaseQty: `1`,
            maxPurchaseQty: `0`,
            fkMaxLimitTypeLookupValueId: null,
            maxAllowedQty: `1`,
            maxAllowedValue: `0`,
            totalUsageLimit: `1`,
            limitToOneUsePerCustomer: false,
            requiredQuantity: `0`,
            active: true,
          },
        ],
        dateRanges: [
          { discountScheduleDateRangeId: ``, startDate: ``, endDate: `` },
        ],
        weeklySchedules: [
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `1`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `2`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `3`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `4`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `5`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `6`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
          {
            discountScheduleWeeklyId: ``,
            dayOfWeek: `0`,
            startTime: ``,
            endTime: ``,
            isActive: false,
          },
        ],
      },
    },
  });

  const discountTypeSpecialPricing = watch(
    `SpecialPricing.rules.0.fkDiscountValueTypeLookupValueId`
  )
    ? watch(`SpecialPricing.rules.0.fkDiscountValueTypeLookupValueId.value`)
    : null;
  const discountValueSpecialPricing =
    Number(watch(`SpecialPricing.rules.0.discountValue`)) || 0;


  useEffect(() => {
    // const currentValue = getValues("rules.0.discountValue");
    if (discountValueSpecialPricing > 100 && discountTypeSpecialPricing == 48) {
      setValue("SpecialPricing.rules.0.discountValue", "0");
    }
  }, [discountTypeSpecialPricing, setValue]);

  const discountTypeMixAndMatch = watch(
    `MixAndMatch.rules.0.fkDiscountValueTypeLookupValueId`
  )
    ? watch(`MixAndMatch.rules.0.fkDiscountValueTypeLookupValueId.value`)
    : null;
  const discountValueMixAndMatch =
    Number(watch(`MixAndMatch.rules.0.discountValue`)) || 0;

  useEffect(() => {
    // const currentValue = getValues("rules.0.discountValue");
    if (discountValueMixAndMatch > 100 && discountTypeMixAndMatch == 48) {
      setValue("MixAndMatch.rules.0.discountValue", "0");
    }
  }, [discountTypeMixAndMatch, setValue]);

  const categoriesApi = useCategoriesApi();
  const { showLoader, hideLoader } = useAppLoader();
  const [saving, setSaving] = useState<boolean>(false);
  const [showAddDiscountModal, setShowAddDiscountModal] =
    useState<boolean>(false);
  const [showSelectAllModal, setShowSelectAllModal] =
    useState<boolean>(false);
  const maxdiscountrenderRefSpecialPricing = useRef<boolean>(false);
  const maxdiscountrenderRefMixAndMatch = useRef<boolean>(false);
  const isInitialMount = useRef<boolean>(true);
  const dayNameObj = {
    0: t("createProductDiscount.schedule.dayNames.sunday"),
    1: t("createProductDiscount.schedule.dayNames.monday"),
    2: t("createProductDiscount.schedule.dayNames.tuesday"),
    3: t("createProductDiscount.schedule.dayNames.wednesday"),
    4: t("createProductDiscount.schedule.dayNames.thursday"),
    5: t("createProductDiscount.schedule.dayNames.friday"),
    6: t("createProductDiscount.schedule.dayNames.saturday"),
  };
  const lookup = useLookup();
  const commonApi = useCommonApi();
  const brandsApi = useBrandsApi();
  const unitsApi = useUnitsApi();
  const tagsApi = useTagsApi();
  const vendorsApi = useVendorsApi();
  const isAutomaticWatchSpecialPricing = watch("SpecialPricing.isAutomatic");
  const ui_minrequirementtyopevaluesSpecialPricing = watch(
    "SpecialPricing.rules.0.fkMinimumRequirementTypeLookupValueId"
  );
  const ui_maxdiscountallowedWatchSpecialPricing = watch(
    "SpecialPricing.ui_maxdiscountallowed"
  );
  const ui_maxLimitTypeWatchSpecialPricing = watch(
    "SpecialPricing.rules.0.fkMaxLimitTypeLookupValueId"
  );
  const locations = useLocationsSelector();
  const weeklySchedulesWatchSpecialPricing: any = watch(
    "SpecialPricing.weeklySchedules"
  );
  const isSetDateRangeWatchSpecialPricing: boolean = watch(
    "SpecialPricing.isSetDateRange"
  );
  const isSetScheduleWatchSpecialPricing: boolean = watch(
    "SpecialPricing.isSetSchedule"
  );
  const schedulestartdateWatchSpecialPricing: any = watch(
    "SpecialPricing.dateRanges.0.startDate"
  );
  const scheduleenddateWatchSpecialPricing: any = watch(
    "SpecialPricing.dateRanges.0.endDate"
  );
  const fkCustomerTargetTypeLookupValueIdWatchSpecialPricing = watch(
    "SpecialPricing.fkCustomerTargetTypeLookupValueId"
  );
  const isAutomaticWatchMixAndMatch = watch("MixAndMatch.isAutomatic");
  const ui_minrequirementtyopevaluesMixAndMatch = watch(
    "MixAndMatch.rules.0.fkMinimumRequirementTypeLookupValueId"
  );
  const ui_maxdiscountallowedWatchMixAndMatch = watch(
    "MixAndMatch.ui_maxdiscountallowed"
  );
  const ui_maxLimitTypeWatchMixAndMatch = watch(
    "MixAndMatch.rules.0.fkMaxLimitTypeLookupValueId"
  );
  const weeklySchedulesWatchMixAndMatch: any = watch(
    "MixAndMatch.weeklySchedules"
  );
  const isSetDateRangeWatchMixAndMatch: boolean = watch(
    "MixAndMatch.isSetDateRange"
  );
  const isSetScheduleWatchMixAndMatch: boolean = watch(
    "MixAndMatch.isSetSchedule"
  );
  const schedulestartdateWatchMixAndMatch: any = watch(
    "MixAndMatch.dateRanges.0.startDate"
  );
  const scheduleenddateWatchMixAndMatch: any = watch(
    "MixAndMatch.dateRanges.0.endDate"
  );
  const fkCustomerTargetTypeLookupValueIdWatchMixAndMatch = watch(
    "MixAndMatch.fkCustomerTargetTypeLookupValueId"
  );

  const [isSpecialPricingSubmitted, setIsSpecialPricingSubmitted] =
    useState(false);
  const [isMixAndMatchSubmitted, setIsMixAndMatchSubmitted] = useState(false);

  const specialPricingLabel = <div className="flex items-center gap-1">{t("createProductDiscount.tabs.specialPricing")} <span className="cursor-pointer text-secondary"><Icon name="info" size={14} title={t("createProductDiscount.tabs.specialPricingInfo")} /></span></div>;
  const mixAndMatchLabel = <div className="flex items-center gap-1">{t("createProductDiscount.tabs.mixMatchPricing")} <span className="cursor-pointer text-secondary"><Icon name="info" size={14} title={t("createProductDiscount.tabs.mixMatchPricingInfo")} /></span></div>;

  const tabs = useMemo(() => {
    if (isSpecialPricingSubmitted && !isMixAndMatchSubmitted) {
      return [
        { name: "Special Pricing", label: specialPricingLabel, disabled: true },
        { name: "Mix & Match Pricing", label: mixAndMatchLabel, disabled: false },
      ];
    } else if (!isSpecialPricingSubmitted && isMixAndMatchSubmitted) {
      return [
        { name: "Special Pricing", label: specialPricingLabel, disabled: false },
        { name: "Mix & Match Pricing", label: mixAndMatchLabel, disabled: true },
      ];
    } else {
      return [
        { name: "Special Pricing", label: specialPricingLabel, disabled: false },
        { name: "Mix & Match Pricing", label: mixAndMatchLabel, disabled: false },
      ];
    }
  }, [isSpecialPricingSubmitted, isMixAndMatchSubmitted, i18n.language]);

  const [activeTab, setActiveTab] = useState("Special Pricing");

  useEffect(() => {
    if (activeTab === "Special Pricing") {
      setTimeout(() => setFocus("SpecialPricing.discountName"), 50);
    }
    if (activeTab === "Mix & Match Pricing") {
      setTimeout(() => setFocus("MixAndMatch.discountName"), 50);
    }
  }, [activeTab]);

  const [categoryDisabledSpecialPricing, setCategoryDisabledSpecialPricing] =
    useState(false);
  const [productDataSpecialPricing, setProductDataSpecialPricing] =
    useState<any>(null);
  const [productDataTreeSpecialPricing, setProductDataTreeSpecialPricing] =
    useState<any>(null);
  const [
    discountCombinationsSpecialPricing,
    setDiscountCombinationsSpecialPricing,
  ] = useState<any[]>([]);
  const [categoryDisabledMixAndMatch, setCategoryDisabledMixAndMatch] =
    useState(false);
  const [productDataMixAndMatch, setProductDataMixAndMatch] =
    useState<any>(null);
  const [productDataTreeMixAndMatch, setProductDataTreeMixAndMatch] =
    useState<any>(null);
  const [discountCombinationsMixAndMatch, setDiscountCombinationsMixAndMatch] =
    useState<any[]>([]);
  const locationsWatchSpecialPricing: any = watch("SpecialPricing.locations");
  const locationsWatchMixAndMatch: any = watch("MixAndMatch.locations");

  const generateUniqueCode = (length = 5): string => {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code.toUpperCase();
  };

  const closeAddDiscountModal = (success: boolean = false) => {
    setShowAddDiscountModal(false);
  };

  const closeSelectAllModal = () => {
    setShowSelectAllModal(false);
  };

  const handleTabChange = (tabName: string) => {
    setActiveTab(tabName);
  };

  const inventoryDataSpecialPricing = useMemo(() => {
    const data: { [key: string]: any } = {};

    productDataTreeSpecialPricing?.forEach((product: any) => {
      const getInventoryOptions = (inventoryLevels: any[]) => {
        if (!inventoryLevels || inventoryLevels.length === 0) {
          return [{ label: t("createProductDiscount.values.noStockData"), value: "none" }];
        }

        // Get selected location IDs
        const selectedLocationIds = locationsWatchSpecialPricing?.map((loc: any) => loc.value) || [];
        
        // Filter inventory levels to only include selected locations
        const filteredInventoryLevels = inventoryLevels.filter((level: any) =>
          selectedLocationIds.includes(level.fkLocationId)
        );

        if (filteredInventoryLevels.length === 0) {
          return [{ label: t("createProductDiscount.values.noStockData"), value: "none" }];
        }

        // Group by fkLocationId and sum quantities
        const locationMap = new Map();

        filteredInventoryLevels.forEach((level: any) => {
          const locationId = level.fkLocationId;
          const quantity = level.quantityInStock || 0;

          if (locationMap.has(locationId)) {
            locationMap.set(locationId, locationMap.get(locationId) + quantity);
          } else {
            locationMap.set(locationId, quantity);
          }
        });

        // Convert to options array
        return Array.from(locationMap.entries()).map(
          ([locationId, totalQuantity]) => {
            // Find location name from locations selector using fkLocationId
            const location = locations?.find(
              (loc: any) => loc.locationId === locationId
            );
            const locationName = location?.locationName || t("createProductDiscount.values.unknownLocation");

            return {
              label: product.trackInventory === false
                ? `${locationName} (-)`
                : `${locationName} (${totalQuantity})`,
              value: locationId || "unknown",
            };
          }
        );
      };

      const inventoryOptions = getInventoryOptions(product.inventoryLevels);
      const firstOption = inventoryOptions[0];

      data[product.id] = {
        options: inventoryOptions,
        firstOption,
        displayText: firstOption?.label || t("createProductDiscount.values.noStock"),
      };
    });

    return data;
  }, [productDataTreeSpecialPricing, locations, locationsWatchSpecialPricing, t]);

  const inventoryDataMixAndMatch = useMemo(() => {
    const data: { [key: string]: any } = {};

    productDataTreeMixAndMatch?.forEach((product: any) => {
      const getInventoryOptions = (inventoryLevels: any[]) => {
        if (!inventoryLevels || inventoryLevels.length === 0) {
          return [{ label: t("createProductDiscount.values.noStockData"), value: "none" }];
        }

        // Get selected location IDs
        const selectedLocationIds = locationsWatchMixAndMatch?.map((loc: any) => loc.value) || [];
        
        // Filter inventory levels to only include selected locations
        const filteredInventoryLevels = inventoryLevels.filter((level: any) =>
          selectedLocationIds.includes(level.fkLocationId)
        );

        if (filteredInventoryLevels.length === 0) {
          return [{ label: t("createProductDiscount.values.noStockData"), value: "none" }];
        }

        // Group by fkLocationId and sum quantities
        const locationMap = new Map();

        filteredInventoryLevels.forEach((level: any) => {
          const locationId = level.fkLocationId;
          const quantity = level.quantityInStock || 0;

          if (locationMap.has(locationId)) {
            locationMap.set(locationId, locationMap.get(locationId) + quantity);
          } else {
            locationMap.set(locationId, quantity);
          }
        });

        // Convert to options array
        return Array.from(locationMap.entries()).map(
          ([locationId, totalQuantity]) => {
            // Find location name from locations selector using fkLocationId
            const location = locations?.find(
              (loc: any) => loc.locationId === locationId
            );
            const locationName = location?.locationName || t("createProductDiscount.values.unknownLocation");

            return {
              label: product.trackInventory === false
                ? `${locationName} (-)`
                : `${locationName} (${totalQuantity})`,
              value: locationId || "unknown",
            };
          }
        );
      };

      const inventoryOptions = getInventoryOptions(product.inventoryLevels);
      const firstOption = inventoryOptions[0];

      data[product.id] = {
        options: inventoryOptions,
        firstOption,
        displayText: firstOption?.label || t("createProductDiscount.values.noStock"),
      };
    });

    return data;
  }, [productDataTreeMixAndMatch, locations, locationsWatchMixAndMatch, t]);

  const searchConfirmSpecialPricing = (selectedProducts: any) => {
    // console.log("Product Data is: ->", productData);
    // console.log("Selected products are: ->", selectedProducts);

    if (!productDataSpecialPricing || productDataSpecialPricing.length === 0) {
      // If no existing data, just set the selected products
      setProductDataSpecialPricing(selectedProducts);
    } else {
      // Smart merge logic
      const updatedProductData: any[] = [];

      // First, add existing items that are still in selectedProducts (preserve existing data)
      productDataSpecialPricing.forEach((existingProduct: any) => {
        const foundInSelected = selectedProducts.find(
          (sp: any) => sp.productId === existingProduct.productId
        );
        if (foundInSelected) {
          updatedProductData.push(existingProduct);
        }
      });

      // Then, add new items from selectedProducts that weren't in productData
      selectedProducts.forEach((selectedProduct: any) => {
        const existsInCurrent = productDataSpecialPricing.find(
          (pd: any) => pd.productId === selectedProduct.productId
        );
        if (!existsInCurrent) {
          updatedProductData.push(selectedProduct);
        }
      });

      setProductDataSpecialPricing(updatedProductData);
    }

    setShowAddDiscountModal(false);
  };

  const searchConfirmMixAndMatch = (selectedProducts: any) => {
    // console.log("Product Data is: ->", productData);
    // console.log("Selected products are: ->", selectedProducts);

    if (!productDataMixAndMatch || productDataMixAndMatch.length === 0) {
      // If no existing data, just set the selected products
      setProductDataMixAndMatch(selectedProducts);
    } else {
      // Smart merge logic
      const updatedProductData: any[] = [];

      // First, add existing items that are still in selectedProducts (preserve existing data)
      productDataMixAndMatch.forEach((existingProduct: any) => {
        const foundInSelected = selectedProducts.find(
          (sp: any) => sp.productId === existingProduct.productId
        );
        if (foundInSelected) {
          updatedProductData.push(existingProduct);
        }
      });

      // Then, add new items from selectedProducts that weren't in productData
      selectedProducts.forEach((selectedProduct: any) => {
        const existsInCurrent = productDataMixAndMatch.find(
          (pd: any) => pd.productId === selectedProduct.productId
        );
        if (!existsInCurrent) {
          updatedProductData.push(selectedProduct);
        }
      });

      setProductDataMixAndMatch(updatedProductData);
    }

    setShowAddDiscountModal(false);
  };

  const confirmDeleteSpecialPricing = async (product: any) => {
    // console.log("Delete product is: ->", product);
    setProductDataSpecialPricing((prev: any) => {
      if (!prev) return prev;
      return prev.filter((p: any) => p.productId !== product.productId);
    });
  };

  const confirmDeleteMixAndMatch = async (product: any) => {
    // console.log("Delete product is: ->", product);
    setProductDataMixAndMatch((prev: any) => {
      if (!prev) return prev;
      return prev.filter((p: any) => p.productId !== product.productId);
    });
  };

  const transformProductsToTree = (products: any[]): any[] => {
    const result: any[] = [];

    products.forEach((product: any) => {
      // Add main product
      const mainProduct = {
        ...product,
        id: product.productId,
        name: product.productName,
        level: 0,
        hasChildren: product.variants && product.variants.length > 0,
        expanded: false,
        isVariant: false,
        variantKey: null,
      };

      result.push(mainProduct);

      // Add variants as children if they exist
      if (product.variants && product.variants.length > 0) {
        product.variants.forEach((variant: any, index: number) => {
          const variantProduct = {
            ...product, // Inherit product data first
            ...variant, // Then override with variant-specific data
            variants: undefined, // Remove variants from variant to avoid recursion
            id: `${product.productId}_${variant.productVariantDetailId}`,
            productId: product.productId,
            variantId: variant.productVariantDetailId,
            name: `${product.productName} - ${
              variant.attributes
                ?.map(
                  (attr: any) => `${attr.attributeName}: ${attr.attributeValue}`
                )
                .join(", ") || `Variant ${index + 1}`
            }`,
            productName: `${product.productName} - ${
              variant.attributes
                ?.map(
                  (attr: any) => `${attr.attributeName}: ${attr.attributeValue}`
                )
                .join(", ") || `Variant ${index + 1}`
            }`,
            level: 1,
            hasChildren: false,
            expanded: false,
            isVariant: true,
            variantKey: variant.productVariantDetailId,
            parentId: product.productId,
            // Ensure variant-specific data takes precedence
            prices: variant.prices || [],
            inventoryLevels: variant.inventoryLevels || [],
            productImages: variant.productImages || product.productImages || [],
            isActive: variant.isActive, // Explicitly preserve variant's isActive status
          };

          result.push(variantProduct);
        });
      }
    });

    return result;
  };

  const handleToggleExpandSpecialPricing = (productId: string) => {
    setExpandedProductsSpecialPricing((prev) => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(productId)) {
        newExpanded.delete(productId);
      } else {
        newExpanded.add(productId);
      }
      return newExpanded;
    });
  };

  const handleToggleExpandMixAndMatch = (productId: string) => {
    setExpandedProductsMixAndMatch((prev) => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(productId)) {
        newExpanded.delete(productId);
      } else {
        newExpanded.add(productId);
      }
      return newExpanded;
    });
  };

  const handleProductSelectionSpecialPricing = (
    product: any,
    isActive: boolean
  ) => {
    // console.log("productData before toggle is: ->", productData);
    // console.log("current product / product Variant is : ->", product);
    // console.log("isActive value is : ->", isActive);

    setProductDataSpecialPricing((prevProductData: any[]) => {
      return prevProductData?.map((p: any) => {
        // If this is a main product (not a variant)
        if (!product.isVariant && p.productId === product.productId) {
          // Update main product isActive
          const updatedProduct = { ...p, isActive: isActive };
          // console.log("Updated main product is: ->", updatedProduct);

          // Set all variants to the same isActive status as the parent product
          if (updatedProduct.variants && updatedProduct.variants.length > 0) {
            updatedProduct.variants = updatedProduct.variants?.map(
              (variant: any) => ({
                ...variant,
                isActive: isActive,
              })
            );
          }

          return updatedProduct;
        }

        // If this is a variant and we found the parent product
        if (
          product.isVariant &&
          p.productId === product.productId &&
          p.variants &&
          p.variants.length > 0
        ) {
          const updatedVariants = p.variants?.map((variant: any) => {
            if (variant.productVariantDetailId === product.variantId) {
              // console.log("Updating variant: ->", {...variant, isActive});
              return { ...variant, isActive: isActive };
            }
            return variant;
          });

          // Check if all variants are active to determine parent product status
          const allVariantsActive = updatedVariants.every(
            (variant: any) => variant.isActive
          );

          return {
            ...p,
            variants: updatedVariants,
            isActive: allVariantsActive, // Parent is active only if ALL variants are active
          };
        }

        return p;
      });
    });
  };

  const handleProductSelectionMixAndMatch = (
    product: any,
    isActive: boolean
  ) => {
    // console.log("productData before toggle is: ->", productData);
    // console.log("current product / product Variant is : ->", product);
    // console.log("isActive value is : ->", isActive);
    setProductDataMixAndMatch((prevProductData: any[]) => {
      return prevProductData?.map((p: any) => {
        // If this is a main product (not a variant)
        if (!product.isVariant && p.productId === product.productId) {
          // Update main product isActive
          const updatedProduct = { ...p, isActive: isActive };
          // console.log("Updated main product is: ->", updatedProduct);

          // Set all variants to the same isActive status as the parent product
          if (updatedProduct.variants && updatedProduct.variants.length > 0) {
            updatedProduct.variants = updatedProduct.variants?.map(
              (variant: any) => ({
                ...variant,
                isActive: isActive,
              })
            );
          }

          return updatedProduct;
        }

        // If this is a variant and we found the parent product
        if (
          product.isVariant &&
          p.productId === product.productId &&
          p.variants &&
          p.variants.length > 0
        ) {
          const updatedVariants = p.variants?.map((variant: any) => {
            if (variant.productVariantDetailId === product.variantId) {
              // console.log("Updating variant: ->", {...variant, isActive});
              return { ...variant, isActive: isActive };
            }
            return variant;
          });

          // Check if all variants are active to determine parent product status
          const allVariantsActive = updatedVariants.every(
            (variant: any) => variant.isActive
          );

          return {
            ...p,
            variants: updatedVariants,
            isActive: allVariantsActive, // Parent is active only if ALL variants are active
          };
        }

        return p;
      });
    });
  };

  const getVisibleProductsSpecialPricing = () => {
    return productDataTreeSpecialPricing?.filter((product: any) => {
      if (!product.isVariant) {
        return true; // Always show main products
      }
      // Show variants only if their parent is expanded
      return expandedProductsSpecialPricing.has(product.parentId);
    });
  };

  const getVisibleProductsMixAndMatch = () => {
    return productDataTreeMixAndMatch?.filter((product: any) => {
      if (!product.isVariant) {
        return true; // Always show main products
      }
      // Show variants only if their parent is expanded
      return expandedProductsMixAndMatch.has(product.parentId);
    });
  };

  useEffect(() => {
    const transformedProductSpecialPricing = transformProductsToTree(
      productDataSpecialPricing || []
    );
    // console.log("Transformed Product Data Tree: ->", transformedProduct);
    setProductDataTreeSpecialPricing(transformedProductSpecialPricing);
  }, [productDataSpecialPricing]);

  useEffect(() => {
    const transformedProductMixAndMatch = transformProductsToTree(
      productDataMixAndMatch || []
    );
    // console.log("Transformed Product Data Tree: ->", transformedProduct);
    setProductDataTreeMixAndMatch(transformedProductMixAndMatch);
  }, [productDataMixAndMatch]);

  useEffect(() => {
    categoriesApi.searchCategory(
      {},
      () => {
        // Categories loaded successfully and stored in Redux
      },
      (error: any) => {
        console.log("Categories load error:", error);
      }
    );

    // Load locations - saga will automatically store in Redux
    commonApi.locationSearch(
      {},
      () => {},
      (error: any) => {
        console.log("Locations load error:", error);
      }
    );

    // Load brands - saga will automatically store in Redux
    brandsApi.searchBrand(
      {},
      () => {},
      (error: any) => {
        console.log("Brands load error:", error);
      }
    );

    // Load units - saga will automatically store in Redux
    unitsApi.searchUnit(
      {},
      () => {},
      (error: any) => {
        console.log("Units load error:", error);
      }
    );

    // Load tags - saga will automatically store in Redux
    tagsApi.searchTag(
      {},
      () => {},
      (error: any) => {
        console.log("Tags load error:", error);
      }
    );

    // Load vendors - saga will automatically store in Redux
    vendorsApi.searchVendor(
      {},
      () => {},
      (error: any) => {
        console.log("Vendors load error:", error);
      }
    );
  }, []);

  useEffect(() => {
    if (
      ui_maxdiscountallowedWatchSpecialPricing &&
      typeof ui_maxdiscountallowedWatchSpecialPricing !== `undefined` &&
      typeof ui_maxdiscountallowedWatchSpecialPricing === `object` &&
      (ui_maxdiscountallowedWatchSpecialPricing as any)?.value
    ) {
      setValue(
        `SpecialPricing.rules.0.limitToOneUsePerCustomer`,
        (ui_maxdiscountallowedWatchSpecialPricing as any)?.value === 130
      );
      setValue(
        `SpecialPricing.rules.0.totalUsageLimit`,
        (ui_maxdiscountallowedWatchSpecialPricing as any)?.value === 130
          ? `1`
          : getValues(`SpecialPricing.rules.0.totalUsageLimit`) > 0
          ? getValues(`SpecialPricing.rules.0.totalUsageLimit`)
          : `1`
      );
    } else {
      setValue(`SpecialPricing.rules.0.limitToOneUsePerCustomer`, false);
    }
  }, [ui_maxdiscountallowedWatchSpecialPricing]);

  useEffect(() => {
    if (
      ui_maxdiscountallowedWatchMixAndMatch &&
      typeof ui_maxdiscountallowedWatchMixAndMatch !== `undefined` &&
      typeof ui_maxdiscountallowedWatchMixAndMatch === `object` &&
      (ui_maxdiscountallowedWatchMixAndMatch as any)?.value
    ) {
      setValue(
        `MixAndMatch.rules.0.limitToOneUsePerCustomer`,
        (ui_maxdiscountallowedWatchMixAndMatch as any)?.value === 130
      );
      setValue(
        `MixAndMatch.rules.0.totalUsageLimit`,
        (ui_maxdiscountallowedWatchMixAndMatch as any)?.value === 130
          ? `1`
          : getValues(`MixAndMatch.rules.0.totalUsageLimit`) > 0
          ? getValues(`MixAndMatch.rules.0.totalUsageLimit`)
          : `1`
      );
    } else {
      setValue(`MixAndMatch.rules.0.limitToOneUsePerCustomer`, false);
    }
  }, [ui_maxdiscountallowedWatchMixAndMatch]);

  useEffect(() => {
    if (
      ui_minrequirementtyopevaluesSpecialPricing &&
      typeof ui_minrequirementtyopevaluesSpecialPricing !== `undefined` &&
      typeof ui_minrequirementtyopevaluesSpecialPricing === `object` &&
      (ui_minrequirementtyopevaluesSpecialPricing as any)?.value
    ) {
      const val = (ui_minrequirementtyopevaluesSpecialPricing as any)?.value;
      if (val == `125`) {
        setValue(`SpecialPricing.rules.0.minPurchaseQty`, `1`);
      }
    }
  }, [ui_minrequirementtyopevaluesSpecialPricing]);

  useEffect(() => {
    if (
      ui_minrequirementtyopevaluesMixAndMatch &&
      typeof ui_minrequirementtyopevaluesMixAndMatch !== `undefined` &&
      typeof ui_minrequirementtyopevaluesMixAndMatch === `object` &&
      (ui_minrequirementtyopevaluesMixAndMatch as any)?.value
    ) {
      const val = (ui_minrequirementtyopevaluesMixAndMatch as any)?.value;
      if (val == `125`) {
        setValue(`MixAndMatch.rules.0.minPurchaseQty`, `1`);
      }
    }
  }, [ui_minrequirementtyopevaluesMixAndMatch]);

  useEffect(() => {
    if (
      ui_maxLimitTypeWatchSpecialPricing &&
      typeof ui_maxLimitTypeWatchSpecialPricing !== `undefined` &&
      typeof ui_maxLimitTypeWatchSpecialPricing === `object` &&
      (ui_maxLimitTypeWatchSpecialPricing as any)?.value
    ) {
      const val = (ui_maxLimitTypeWatchSpecialPricing as any)?.value;
      if (val == `127`) {
        setValue(`SpecialPricing.rules.0.maxAllowedQty`, ``);
      } else {
        if (
          getValues(`SpecialPricing.rules.0.maxAllowedQty`) == `` ||
          getValues(`SpecialPricing.rules.0.maxAllowedQty`) == `0`
        ) {
          setValue(`SpecialPricing.rules.0.maxAllowedQty`, `1`);
        }
      }
    }
  }, [ui_maxLimitTypeWatchSpecialPricing]);

  useEffect(() => {
    if (
      ui_maxLimitTypeWatchMixAndMatch &&
      typeof ui_maxLimitTypeWatchMixAndMatch !== `undefined` &&
      typeof ui_maxLimitTypeWatchMixAndMatch === `object` &&
      (ui_maxLimitTypeWatchMixAndMatch as any)?.value
    ) {
      const val = (ui_maxLimitTypeWatchMixAndMatch as any)?.value;
      if (val == `127`) {
        setValue(`MixAndMatch.rules.0.maxAllowedQty`, ``);
      } else {
        if (
          getValues(`MixAndMatch.rules.0.maxAllowedQty`) == `` ||
          getValues(`MixAndMatch.rules.0.maxAllowedQty`) == `0`
        ) {
          setValue(`MixAndMatch.rules.0.maxAllowedQty`, `1`);
        }
      }
    }
  }, [ui_maxLimitTypeWatchMixAndMatch]);

  useEffect(() => {
    if (fkCustomerTargetTypeLookupValueIdWatchSpecialPricing === btoa(`139`)) {
      setValue(`SpecialPricing.customerGroups`, []);
    }
  }, [fkCustomerTargetTypeLookupValueIdWatchSpecialPricing]);

  // Validation messages (rules={{ required: t(...) }}) are resolved once, at the
  // moment validation runs, and cached as plain strings in react-hook-form's error
  // state -- they don't re-render on their own. Re-validate any already-errored
  // fields on a language switch so their messages catch up to the new language.
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      trigger();
    }
  }, [i18n.language]);

  const formatDateForAPI = (date: Date | null, isEnd: boolean = false) => {
        if (!date) return undefined;
        if (isEnd) {
          return (
            moment(date).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
            // moment(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
          );
        }
        return (
          moment(date).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
          // moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
        );
  };
  

  const onSubmit = async (data: typeWiseFormValues) => {
    if (activeTab === "Special Pricing") {
      const tabKey = "SpecialPricing";
      const payload = Object.assign(
        {},
        JSON.parse(JSON.stringify(data[tabKey]))
      );

      // Add discountCombinations state to the data for processing
      const enhancedData = {
        ...data[tabKey],
        discountCombination: discountCombinationsSpecialPricing,
      };

      if (
        enhancedData &&
        enhancedData?.locations &&
        Array.isArray(enhancedData.locations) &&
        enhancedData.locations.length > 0
      ) {
        payload.locations = enhancedData.locations.map((x: any) => {
          const lobj = {
            discountLocationId: null,
            fkLocationId: x.value,
            active: true,
          };
          return lobj;
        });
      }

      // Process customer groups
      if (
        data &&
        data[tabKey]?.customerGroups &&
        Array.isArray(data[tabKey].customerGroups) &&
        data[tabKey].customerGroups.length > 0
      ) {
        payload.customerGroups = data[tabKey].customerGroups.map((x: any) => {
          const cgobj = {
            discountCustomerGroupId: null,
            fkCustomerGroupId: x.value,
            active: true,
          };
          return cgobj;
        });
      } else {
        payload.customerGroups = [];
      }

      if (
        enhancedData &&
        enhancedData?.rules &&
        Array.isArray(enhancedData.rules) &&
        enhancedData.rules.length > 0
      ) {
        payload.rules = enhancedData.rules.map((x: any) => ({
          discountRuleId: null,
          fkDiscountValueTypeLookupValueId:
            x.fkDiscountValueTypeLookupValueId &&
            typeof x.fkDiscountValueTypeLookupValueId !== `undefined` &&
            x.fkDiscountValueTypeLookupValueId?.value
              ? btoa(x.fkDiscountValueTypeLookupValueId.value)
              : ``,
          discountValue: Number(x.discountValue) || 0,
          fkMinimumRequirementTypeLookupValueId:
            x.fkMinimumRequirementTypeLookupValueId &&
            typeof x.fkMinimumRequirementTypeLookupValueId !== `undefined` &&
            x.fkMinimumRequirementTypeLookupValueId?.value
              ? btoa(x.fkMinimumRequirementTypeLookupValueId.value)
              : ``,
          minPurchaseAmount: null,
          minPurchaseQty:
            x.fkMinimumRequirementTypeLookupValueId?.value == `126` ||
            x.fkMinimumRequirementTypeLookupValueId == `126`
              ? Number(x.minPurchaseQty)
              : null,
          maxPurchaseQty: null,
          fkMaxLimitTypeLookupValueId:
            x.fkMaxLimitTypeLookupValueId &&
            typeof x.fkMaxLimitTypeLookupValueId !== `undefined` &&
            x.fkMaxLimitTypeLookupValueId?.value
              ? btoa(x.fkMaxLimitTypeLookupValueId.value)
              : ``,
          maxAllowedQty:
            x.fkMaxLimitTypeLookupValueId?.value == `128` ||
            x.fkMaxLimitTypeLookupValueId == `128`
              ? Number(x.maxAllowedQty)
              : null,
          maxAllowedValue: null,
          totalUsageLimit: x.limitToOneUsePerCustomer
            ? null
            : x?.totalUsageLimit || 1,
          limitToOneUsePerCustomer: x.limitToOneUsePerCustomer,
          requiredQuantity: null,
          active: true,
        }));

        // console.log("Processed rules payload:", data.rules[0]);
      }

      if (
        enhancedData &&
        enhancedData?.isSetDateRange &&
        enhancedData?.dateRanges &&
        Array.isArray(enhancedData.dateRanges) &&
        enhancedData.dateRanges.length > 0
      ) {
        payload.dateRanges = enhancedData.dateRanges.map((x: any) => ({
          discountScheduleDateRangeId: ``,
          // startDate: moment(x.startDate).utc().toISOString(),
          // endDate: moment(x.endDate).utc().toISOString(),
          startDate: formatDateForAPI(x.startDate),
          endDate: formatDateForAPI(x.endDate, true),
        }));
      } else {
        payload.dateRanges = [];
      }

      if (
        enhancedData &&
        enhancedData?.isSetSchedule &&
        enhancedData.isSetSchedule === true &&
        enhancedData?.weeklySchedules &&
        Array.isArray(enhancedData.weeklySchedules) &&
        enhancedData.weeklySchedules.length > 0
      ) {
        payload.weeklySchedules = enhancedData.weeklySchedules
          .filter((x: any) => x.isActive)
          .map((x: any) => {
            var lobj = {
              discountScheduleWeeklyId: ``,
              dayOfWeek: x.dayOfWeek,
              startTime: x.startTime
                ? moment(x.startTime).utc().format(`HH:mm`)
                : null,
              endTime: x.endTime
                ? moment(x.endTime).utc().format(`HH:mm`)
                : null,
              // startTime: x.startTime
              //   ? moment(x.startTime).format(`HH:mm`)
              //   : null,
              // endTime: x.endTime ? moment(x.endTime).format(`HH:mm`) : null,
              isActive: x.isActive,
            };
            return lobj;
          });
      } else {
        payload.weeklySchedules = [];
      }

      // Process discount combinations
      if (
        enhancedData &&
        enhancedData?.discountCombination &&
        Array.isArray(enhancedData.discountCombination) &&
        enhancedData.discountCombination.length > 0
      ) {
        payload.discountCombination = enhancedData.discountCombination.map(
          (x: any) => ({
            fkCombinationsLookupValueId: btoa(x.value),
          })
        );
      } else {
        payload.discountCombination = [];
      }

      delete payload.ui_maxdiscountallowed;
      payload.fkDiscountTypeLookupValueId = "MTM0";
      payload.products =
        productDataTreeSpecialPricing?.map((p: any) => ({
          // discountProductId: null,
          fkProductId: p.productId,
          fkProductVariantDetailId: p.isVariant ? p.variantId : null,
          // fkProductRoleLookupValueId: p.isActive ? btoa(`33`) : btoa(`34`),
          // requiredQuantity: 0,
          fkProductStatusLookupValueId: p.isActive ? btoa(`141`) : btoa(`142`),
        })) || [];
      payload.discountCode = generateUniqueCode(10);
      // console.log("Final processed payload is: ->", payload);
      setSaving(true);
      showLoader();
      const couponresp: any = await new Promise((resolve, reject) =>
        discountApi.addUpdateDiscount(payload, resolve, reject)
      ).catch((err) => null);
      setSaving(false);
      hideLoader();
      // console.log("Coupon Response", couponresp);
      if (couponresp && couponresp?.success && couponresp.success == true) {
        toast.success(t("createProductDiscount.toasts.saveSpecialPricingSuccess"));
        setIsSpecialPricingSubmitted(true);
        if (isMixAndMatchSubmitted) {
          navigate(URLS.DISCOUNT);
        } else {
          setActiveTab("Mix & Match Pricing");
        }
      } else {
        toast.error(couponresp?.errorMessage || t("createProductDiscount.toasts.saveFailed"));
      }
      setIsSpecialPricingSubmitted(true);
    } else if (activeTab === "Mix & Match Pricing") {
      const tabKey = "MixAndMatch";

      const payload = Object.assign(
        {},
        JSON.parse(JSON.stringify(data[tabKey]))
      );

      // Add discountCombinations state to the data for processing
      const enhancedData = {
        ...data[tabKey],
        discountCombination: discountCombinationsMixAndMatch,
      };

      if (
        enhancedData &&
        enhancedData?.locations &&
        Array.isArray(enhancedData.locations) &&
        enhancedData.locations.length > 0
      ) {
        payload.locations = enhancedData.locations.map((x: any) => {
          const lobj = {
            discountLocationId: null,
            fkLocationId: x.value,
            active: true,
          };
          return lobj;
        });
      }

      // Process customer groups
      if (
        data[tabKey] &&
        data[tabKey]?.customerGroups &&
        Array.isArray(data[tabKey].customerGroups) &&
        data[tabKey].customerGroups.length > 0
      ) {
        payload.customerGroups = data[tabKey].customerGroups.map((x: any) => {
          const cgobj = {
            discountCustomerGroupId: null,
            fkCustomerGroupId: x.value,
            active: true,
          };
          return cgobj;
        });
      } else {
        payload.customerGroups = [];
      }

      if (
        enhancedData &&
        enhancedData?.rules &&
        Array.isArray(enhancedData.rules) &&
        enhancedData.rules.length > 0
      ) {
        payload.rules = enhancedData.rules.map((x: any) => ({
          discountRuleId: null,
          fkDiscountValueTypeLookupValueId:
            x.fkDiscountValueTypeLookupValueId &&
            typeof x.fkDiscountValueTypeLookupValueId !== `undefined` &&
            x.fkDiscountValueTypeLookupValueId?.value
              ? btoa(x.fkDiscountValueTypeLookupValueId.value)
              : ``,
          discountValue: Number(x.discountValue) || 0,
          fkMinimumRequirementTypeLookupValueId:
            x.fkMinimumRequirementTypeLookupValueId &&
            typeof x.fkMinimumRequirementTypeLookupValueId !== `undefined` &&
            x.fkMinimumRequirementTypeLookupValueId?.value
              ? btoa(x.fkMinimumRequirementTypeLookupValueId.value)
              : ``,
          minPurchaseAmount: null,
          minPurchaseQty:
            x.fkMinimumRequirementTypeLookupValueId?.value == `126` ||
            x.fkMinimumRequirementTypeLookupValueId == `126`
              ? Number(x.minPurchaseQty)
              : null,
          maxPurchaseQty: null,
          fkMaxLimitTypeLookupValueId:
            x.fkMaxLimitTypeLookupValueId &&
            typeof x.fkMaxLimitTypeLookupValueId !== `undefined` &&
            x.fkMaxLimitTypeLookupValueId?.value
              ? btoa(x.fkMaxLimitTypeLookupValueId.value)
              : ``,
          maxAllowedQty:
            x.fkMaxLimitTypeLookupValueId?.value == `128` ||
            x.fkMaxLimitTypeLookupValueId == `128`
              ? Number(x.maxAllowedQty)
              : null,
          maxAllowedValue: null,
          totalUsageLimit: x.limitToOneUsePerCustomer
            ? null
            : x?.totalUsageLimit || 1,
          limitToOneUsePerCustomer: x.limitToOneUsePerCustomer,
          requiredQuantity: null,
          active: true,
        }));

        // console.log("Processed rules payload:", data.rules[0]);
      }

      if (
        enhancedData &&
        enhancedData?.isSetDateRange &&
        enhancedData?.dateRanges &&
        Array.isArray(enhancedData.dateRanges) &&
        enhancedData.dateRanges.length > 0
      ) {
        payload.dateRanges = enhancedData.dateRanges.map((x: any) => ({
          discountScheduleDateRangeId: ``,
          // startDate: moment(x.startDate).utc().toISOString(),
          // endDate: moment(x.endDate).utc().toISOString(),
          startDate: formatDateForAPI(x.startDate),
          endDate: formatDateForAPI(x.endDate, true),
        }));
      } else {
        payload.dateRanges = [];
      }

      if (
        enhancedData &&
        enhancedData?.isSetSchedule &&
        enhancedData.isSetSchedule === true &&
        enhancedData?.weeklySchedules &&
        Array.isArray(enhancedData.weeklySchedules) &&
        enhancedData.weeklySchedules.length > 0
      ) {
        payload.weeklySchedules = enhancedData.weeklySchedules
          .filter((x: any) => x.isActive)
          .map((x: any) => {
            var lobj = {
              discountScheduleWeeklyId: ``,
              dayOfWeek: x.dayOfWeek,
              startTime: x.startTime
                ? moment(x.startTime).utc().format(`HH:mm`)
                : null,
              endTime: x.endTime
                ? moment(x.endTime).utc().format(`HH:mm`)
                : null,
              // startTime: x.startTime
              //   ? moment(x.startTime).format(`HH:mm`)
              //   : null,
              // endTime: x.endTime ? moment(x.endTime).format(`HH:mm`) : null,
              isActive: x.isActive,
            };
            return lobj;
          });
      } else {
        payload.weeklySchedules = [];
      }

      // Process discount combinations
      if (
        enhancedData &&
        enhancedData?.discountCombination &&
        Array.isArray(enhancedData.discountCombination) &&
        enhancedData.discountCombination.length > 0
      ) {
        payload.discountCombination = enhancedData.discountCombination.map(
          (x: any) => ({
            fkCombinationsLookupValueId: btoa(x.value),
          })
        );
      } else {
        payload.discountCombination = [];
      }

      delete payload.ui_maxdiscountallowed;
      payload.fkDiscountTypeLookupValueId = "MTM1";
      payload.products =
        productDataTreeMixAndMatch?.map((p: any) => ({
          // discountProductId: null,
          fkProductId: p.productId,
          fkProductVariantDetailId: p.isVariant ? p.variantId : null,
          // fkProductRoleLookupValueId: p.isActive ? btoa(`33`) : btoa(`34`),
          // requiredQuantity: 0,
          fkProductStatusLookupValueId: p.isActive ? btoa(`141`) : btoa(`142`),
        })) || [];
      payload.discountCode = generateUniqueCode(10);
      // console.log("Final processed payload is: ->", payload);
      setSaving(true);
      showLoader();
      const couponresp: any = await new Promise((resolve, reject) =>
        discountApi.addUpdateDiscount(payload, resolve, reject)
      ).catch((err) => null);
      setSaving(false);
      hideLoader();
      // console.log("Coupon Response", couponresp);
      if (couponresp && couponresp?.success && couponresp.success == true) {
        toast.success(t("createProductDiscount.toasts.saveMixAndMatchSuccess"));
        setIsMixAndMatchSubmitted(true);
        if (isSpecialPricingSubmitted) {
          navigate(URLS.DISCOUNT);
        } else {
          setActiveTab("Special Pricing");
        }
      } else {
        toast.error(couponresp?.errorMessage || t("createProductDiscount.toasts.saveFailed"));
      }

      setIsMixAndMatchSubmitted(true);
    }
  };

  const handleCancel = () => {
    if (isMixAndMatchSubmitted || isSpecialPricingSubmitted) {
      navigate(URLS.DISCOUNT);
    } else {
      navigationConfirm(
        t("common.leaveDialog.title"),
        t("common.leaveDialog.message"),
        () => navigate(URLS.DISCOUNT),
        confirm
      );
    }
  };

  return (
    <div>
      <SubHeader
        title={t("createProductDiscount.page.title")}
        subTitle={t("createProductDiscount.page.subtitle")}
      >
        <SiteButtons
          data={[
            {
              text: (isMixAndMatchSubmitted || isSpecialPricingSubmitted) ? t("createProductDiscount.buttons.backToDiscountList") : t("createProductDiscount.buttons.cancel"),
              click: handleCancel,
              theme: "secondary",
            },
            {
              text:
                activeTab === "Special Pricing"
                  ? t("createProductDiscount.buttons.saveSpecialPricing")
                  : t("createProductDiscount.buttons.saveMixAndMatch"),
              type: "submit",
              form: "createProductDiscountForm",
              working: saving,
            },
          ]}
        />
      </SubHeader>
      <Container>
        <div className="flex-grow overflow-auto">
          <form
            onSubmit={handleSubmit(onSubmit)}
            id="createProductDiscountForm"
          >
            <div className="pb-6 pt-6">
              {/* Tabs Section */}
              <div className="mb-6">
                <TopTabs
                  tabs={tabs}
                  activeTab={activeTab}
                  setActiveTab={handleTabChange}
                />
              </div>

              {/* General Section */}
              {activeTab == "Special Pricing" && (
                <div>
                  <div>
                    <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                      <h2 className="text-lg font-semibold mb-2 text-black">
                        {t("createProductDiscount.sections.productDiscountInfo")}
                      </h2>
                    </div>
                    <div className="grid grid-cols-1 gap-6 mb-6">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-normal text-black flex items-center gap-1">
                          {t("createProductDiscount.toggles.manual")}
                          <span className="cursor-pointer text-secondary"><Icon name="info" size={16} title={t("createProductDiscount.toggles.manualInfo")} /></span>
                        </span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer hidden"
                            {...control.register("SpecialPricing.isAutomatic")}
                          />
                          <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                          <span className="ml-2 text-sm font-normal text-black">
                            {t("createProductDiscount.toggles.automatic")}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                      <div>
                        <Controller
                          name="SpecialPricing.discountName"
                          control={control}
                          rules={{
                            required: t("createProductDiscount.validation.codeRequired"),
                            validate: (value: string) =>
                              value?.trim().length > 0 || t("createProductDiscount.validation.codeRequired"),
                          }}
                          render={({ field, fieldState }) => (
                            <Input
                              {...field}
                              className="!my-0 !mb-6"
                              type="text"
                              label={t("createProductDiscount.fields.discountCode")}
                              required
                              placeholder={t("createProductDiscount.placeholders.enterDiscountCode")}
                              error={fieldState.error?.message}
                            />
                          )}
                        />
                        <div>
                          <CommonDropdown
                            control={control}
                            setValue={setValue}
                            rules={{ required: t("createProductDiscount.validation.locationRequired") }}
                            label={t("createProductDiscount.fields.location")}
                            name="SpecialPricing.locations"
                            type="location"
                            placeholder={t("createProductDiscount.placeholders.selectLocation")}
                            required={true}
                            isMulti={true}
                          />
                        </div>
                      </div>
                      <Controller
                        name="SpecialPricing.discountDescription"
                        control={control}
                        render={({ field, fieldState }) => (
                          <Textarea
                            {...field}
                            className="!my-0 w-full"
                            mainElementClassName={`h-[132px]`}
                            label={t("createProductDiscount.fields.discountDescription")}
                            placeholder={t("createProductDiscount.placeholders.description")}
                            error={fieldState.error?.message}
                          />
                        )}
                      />
                    </div>
                  </div>

                  {/* Discount Rule Section */}
                  <div>
                    <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                      <h2 className="text-lg font-semibold mb-2 text-black">
                        {t("productDiscount.sections.discountRule")}
                      </h2>
                      <p className="mb-4 text-sm text-black">
                        {t("productDiscount.sections.discountRuleSubtitle")}
                      </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-0">
                        <div>
                          <CommonDropdown
                            preSelectValues={"48"}
                            control={control}
                            setValue={setValue}
                            label={t("createProductDiscount.fields.discountType")}
                            name="SpecialPricing.rules.0.fkDiscountValueTypeLookupValueId"
                            type="lookup"
                            placeholder={t("createProductDiscount.placeholders.selectDiscountType")}
                            required
                            rules={{ required: t("createProductDiscount.validation.discountTypeRequired") }}
                            data={lookup.getDiscountType()}
                          />
                        </div>
                        <Controller
                          name="SpecialPricing.rules.0.discountValue"
                          control={control}
                          rules={{
                            required: t("createProductDiscount.validation.discountValueRequired"),
                            validate: (value) => {
                              const numValue = Number(value);
                              const discountTypeValue =
                                discountTypeSpecialPricing; // This is from watch()

                              // Check if it's a valid number
                              if (isNaN(numValue)) {
                                return t("createProductDiscount.validation.discountValueInvalid");
                              }

                              // Fixed amount discount (assuming ID 47 is fixed amount)
                              if (discountTypeValue == 47) {
                                if (numValue < 0) {
                                  return t("createProductDiscount.validation.fixedDiscountMin");
                                }
                                if (numValue > 1000) {
                                  return t("createProductDiscount.validation.fixedDiscountMax");
                                }
                              }
                              // Percentage discount (assuming other IDs are percentage)
                              else {
                                if (numValue < 0) {
                                  return t("createProductDiscount.validation.percentDiscountMin");
                                }
                                if (numValue > 100) {
                                  return t("createProductDiscount.validation.percentDiscountMax");
                                }
                              }

                              return true;
                            },
                          }}
                          render={({ field, fieldState }) => (
                            <DecimalInput
                              value={field.value}
                              onChange={field.onChange}
                              decimalPlaces={2}
                              min={0}
                              max={
                                discountTypeSpecialPricing == 47 ? 9999999999 : 100
                              }
                              className="!my-0 !mb-6"
                              label={t("createProductDiscount.fields.discountValue")}
                              placeholder="0"
                              required
                              withDollarIcon={discountTypeSpecialPricing == 47}
                              error={fieldState.error?.message as any}
                            />
                          )}
                        />
                        <div>
                          <Label text={t("createProductDiscount.labels.minimumRequirement.text")} info={t("createProductDiscount.labels.minimumRequirement.info")} required />
                          <CommonDropdown
                            control={control}
                            setValue={setValue}
                            label=""
                            name="SpecialPricing.rules.0.fkMinimumRequirementTypeLookupValueId"
                            type="lookup"
                            placeholder={t("createProductDiscount.placeholders.minimumRequirements")}
                            required
                            rules={{
                              required:
                                t("createProductDiscount.validation.minimumPurchaseRequirementRequired"),
                            }}
                            data={lookup.getDiscountMinPurchaseAmount()}
                            labelisElipsis={true}
                          />
                        </div>
                        <Controller
                          name="SpecialPricing.rules.0.minPurchaseQty"
                          control={control}
                          rules={
                            (ui_minrequirementtyopevaluesSpecialPricing as any)
                              ?.value == 126
                              ? {
                                  required: t("createProductDiscount.validation.minPurchaseAmountRequired"),
                                  validate: (value) => {
                                    const numValue = Number(value);
                                    if (isNaN(numValue)) {
                                      return t("createProductDiscount.validation.maxAllowedQtyInvalid");
                                    }
                                    if (numValue < 1) {
                                      return t("createProductDiscount.validation.maxAllowedQtyMin");
                                    }
                                    return true;
                                  },
                                }
                              : {}
                          }
                          disabled={
                            (ui_minrequirementtyopevaluesSpecialPricing as any)
                              ?.value === 125
                          }
                          render={({ field, fieldState }) => (
                            <div>
                              <Label text={t("createProductDiscount.labels.minPurchaseQty.text")} info={t("createProductDiscount.labels.minPurchaseQty.info")} />
                              <DecimalInput
                                value={field.value}
                                onChange={field.onChange}
                                fieldType="unit" // restricts to whole numbers
                                min={0}
                                max={9999999999}
                                className="!my-0 !mb-6"
                                disabled={
                                  (
                                    ui_minrequirementtyopevaluesSpecialPricing as any
                                  )?.value === 125
                                }
                                label=""
                                placeholder="0"
                                required={
                                  (
                                    ui_minrequirementtyopevaluesSpecialPricing as any
                                  )?.value == 126
                                }
                                error={fieldState.error?.message}
                                labelSpaceNeeded
                              />
                            </div>
                          )}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-0">
                      <div>
                        <Label text={t("createProductDiscount.labels.maximumAllowed.text")} info={t("createProductDiscount.labels.maximumAllowed.info")} required />
                        <CommonDropdown
                          control={control}
                          setValue={setValue}
                          label=""
                          name="SpecialPricing.rules.0.fkMaxLimitTypeLookupValueId"
                          type="lookup"
                          placeholder={t("createProductDiscount.labels.maximumAllowed.text")}
                          required
                          rules={{ required: t("createProductDiscount.validation.maximumAllowedRequired") }}
                          data={lookup.getDiscountMaxAllowed()}
                          labelisElipsis={true}
                        />
                      </div>
                      <Controller
                        name="SpecialPricing.rules.0.maxAllowedQty"
                        control={control}
                        rules={
                          (ui_maxLimitTypeWatchSpecialPricing as any)
                            ?.value == 128
                            ? {
                                required: t("createProductDiscount.validation.minPurchaseAmountRequired"),
                                validate: (value) => {
                                  const numValue = Number(value);
                                  if (isNaN(numValue)) {
                                    return t("createProductDiscount.validation.maxAllowedQtyInvalid");
                                  }
                                  if (numValue < 1) {
                                    return t("createProductDiscount.validation.maxAllowedQtyMin");
                                  }
                                  return true;
                                },
                              }
                            : {}
                        }
                        disabled={
                          (ui_maxLimitTypeWatchSpecialPricing as any)
                            ?.value === 127
                        }
                        render={({ field, fieldState }) => (
                          <div>
                            <Label text={t("createProductDiscount.labels.maxAllowedQty.text")} info={t("createProductDiscount.labels.maxAllowedQty.info")} />
                            <DecimalInput
                              value={field.value ?? undefined}
                              onChange={field.onChange}
                              fieldType="unit" // restricts to whole numbers
                              min={0}
                              max={9999999999}
                              className="!my-0 !mb-6"
                              label=""
                              placeholder=""
                              disabled={
                                (ui_maxLimitTypeWatchSpecialPricing as any)
                                  ?.value === 127
                              }
                              required={
                                (ui_maxLimitTypeWatchSpecialPricing as any)
                                  ?.value == 128
                              }
                              error={fieldState.error?.message}
                              labelSpaceNeeded
                            />
                          </div>
                        )}
                      />
                      <div>
                        <Label text={t("createProductDiscount.labels.discountUsageLimit.text")} info={t("createProductDiscount.labels.discountUsageLimit.infoSpecialPricing")} required />
                        <CommonDropdown
                          control={control}
                          setValue={setValue}
                          label=""
                          name="SpecialPricing.ui_maxdiscountallowed"
                          type="lookup"
                          placeholder={t("createProductDiscount.placeholders.maximumDiscountUser")}
                          required
                          rules={{
                            required: t("createProductDiscount.validation.maximumDiscountUserRequired"),
                          }}
                          data={lookup.getDiscountUsageLimit()}
                        />
                      </div>
                      <Controller
                        name="SpecialPricing.rules.0.totalUsageLimit"
                        control={control}
                        rules={
                          (ui_maxdiscountallowedWatchSpecialPricing as any) &&
                          (ui_maxdiscountallowedWatchSpecialPricing as any)
                            ?.value !== 130
                            ? {
                                required: t("createProductDiscount.validation.totalUsageLimitRequired"),
                                validate: (value) => {
                                  const numValue = Number(value);
                                  if (isNaN(numValue)) {
                                    return t("createProductDiscount.validation.maximumDiscountUsageInvalid");
                                  }
                                  if (numValue < 1) {
                                    return t("createProductDiscount.validation.maximumDiscountUsageMin");
                                  }
                                  return true;
                                },
                              }
                            : {}
                        }
                        disabled={
                          (ui_maxdiscountallowedWatchSpecialPricing as any) &&
                          (ui_maxdiscountallowedWatchSpecialPricing as any)
                            ?.value === 130
                        }
                        render={({ field, fieldState }) => (
                          <DecimalInput
                            value={field.value}
                            onChange={field.onChange}
                            fieldType="unit"
                            min={0}
                            max={9999999999}
                            className="!my-0 !mb-6"
                            label={t("createProductDiscount.fields.discountUsageLimitValue")}
                            placeholder="0"
                            disabled={
                              (ui_maxdiscountallowedWatchSpecialPricing as any) &&
                              (ui_maxdiscountallowedWatchSpecialPricing as any)
                                ?.value === 130
                            }
                            required={
                              (ui_maxdiscountallowedWatchSpecialPricing as any) &&
                              (ui_maxdiscountallowedWatchSpecialPricing as any)
                                ?.value !== 130
                            }
                            error={fieldState.error?.message}
                          />
                        )}
                      />
                    </div>
                    {/* <div className="mb-8">
                      <div className="flex items-center gap-1" title="This product discount can be combined with">
                        <Label text="Combinations" />
                        <Icon name="info" className=" text-secondary cursor-pointer" title="This product discount can be combined with"/>
                      </div>
                      <SelectBox
                        value={discountCombinationsSpecialPricing}
                        onChange={(selectedOptions: any) => {
                          setDiscountCombinationsSpecialPricing(
                            selectedOptions || []
                          );
                        }}
                        options={
                          lookup.getDiscountCombination()?.map((item: any) => ({
                            label: item.lookupValue,
                            value: item.lookupId,
                          })) || []
                        }
                        placeholder="Select Combinations"
                        isMulti={true}
                        className="w-full !my-0"
                        isClearable={true}
                      />
                    </div> */}
                  </div>
                  <div className="flex justify-between items-center w-full">
                    <div className="w-1/3">
                      <div className="text-md font-medium col-span-1 flex items-center justify-start">
                        {t("createProductDiscount.sections.selectProductsToDiscount")}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <Button
                        type="button"
                        theme="secondary"
                        onClick={() => {
                          const selectedLocations = getValues("SpecialPricing.locations");
                          if (!selectedLocations || selectedLocations.length === 0) {
                            toast.error(t("createProductDiscount.validation.selectLocationFirst"));
                            return;
                          }
                          setShowSelectAllModal(true);
                        }}
                      >
                        {t("createProductDiscount.buttons.selectAllProducts")}
                      </Button>

                      <Button
                        type="button"
                        onClick={() => {
                          const selectedLocations = getValues("SpecialPricing.locations");
                          if (!selectedLocations || selectedLocations.length === 0) {
                            toast.error(t("createProductDiscount.validation.selectLocationFirst"));
                            return;
                          }
                          setShowAddDiscountModal(true);
                        }}
                      >
                        {t("createProductDiscount.buttons.searchProduct")}
                      </Button>
                    </div>

                    {showAddDiscountModal && (
                      <SiteModal
                        modalWidth={1000}
                        width={true}
                        // className="mt-20"
                        isOpen={showAddDiscountModal}
                        onClose={closeAddDiscountModal}
                        title={t("createProductDiscount.modal.selectProductsTitle")}
                        isBlur={true}
                        closeOnBackdrop={false}
                      >
                        <ProductSearchModal
                          category={[]}
                          location={getValues("SpecialPricing.locations") || []}
                          onClose={closeAddDiscountModal}
                          onConfirm={searchConfirmSpecialPricing}
                          productData={productDataSpecialPricing}
                          disableCategory={activeTab != "Special Pricing"}
                          hideCategory={false}
                        ></ProductSearchModal>
                      </SiteModal>
                    )}

                    {showSelectAllModal && (
                      <SiteModal
                        modalWidth={1000}
                        width={true}
                        isOpen={showSelectAllModal}
                        onClose={closeSelectAllModal}
                        title={t("createProductDiscount.modal.selectProductsTitle")}
                        isBlur={true}
                        closeOnBackdrop={false}
                      >
                        <ProductSearchModalAll
                          category={[]}
                          location={getValues("SpecialPricing.locations") || []}
                          onClose={closeSelectAllModal}
                          onConfirm={(selected: any) => {
                            searchConfirmSpecialPricing(selected);
                            setShowSelectAllModal(false);
                          }}
                          productData={productDataSpecialPricing}
                          disableCategory={activeTab != "Special Pricing"}
                          hideCategory={false}
                        ></ProductSearchModalAll>
                      </SiteModal>
                    )}
                  </div>

                  <div className="mt-6">
                    <ReusableTable
                      paddingBottomNeeded={
                        productDataTreeSpecialPricing?.length > 0
                      }
                      data={getVisibleProductsSpecialPricing()}
                      enableExpand={false}
                      fixedHeight="calc(100vh - 200px)"
                      columns={[
                        {
                          key: "productName",
                          label: t("createProductDiscount.columns.productName"),
                          sortable: false,
                          render: (product: any) => (
                            <div className="flex items-center gap-2">
                              {/* Indentation for tree structure */}
                              <div
                                style={{ marginLeft: product.level * 20 }}
                                className="flex items-center gap-2"
                              >
                                {/* Expand/Collapse button for products with variants */}
                                {product.hasChildren && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleToggleExpandSpecialPricing(
                                        product.productId
                                      )
                                    }
                                    className="w-6 h-6 flex cursor-pointer items-center justify-center text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
                                  >
                                    <Icon
                                      name={
                                        expandedProductsSpecialPricing.has(
                                          product.productId
                                        )
                                          ? "arrowdown"
                                          : "arrowright"
                                      }
                                      className="w-4 h-4"
                                    />
                                  </button>
                                )}
                                {!product.hasChildren &&
                                  product.level === 0 && (
                                    <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                      {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                                    </div>
                                  )}
                                {!product.hasChildren && product.level > 0 && (
                                  <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                    {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                                  </div>
                                )}

                                {/* Product name */}
                                {!product.isVariant ? (
                                  <div>
                                    <div className="font-medium">
                                      {product.productName}
                                    </div>
                                    <div className="border-b-2 border-black my-1"></div>
                                    <div className="text-sm text-gray-500">
                                      {product.hasChildren
                                        ? t("createProductDiscount.values.variantsCount", {
                                            count: productDataTreeSpecialPricing?.filter(
                                              (p: any) =>
                                                p.isVariant &&
                                                p.parentId === product.productId
                                            ).length,
                                          })
                                        : (() => {
                                            const productType = lookup.getProductType()?.find(
                                              (type: any) => btoa(type?.lookupId) === product?.fkProductTypeLookupValueId
                                            );
                                            return productType ? getLookupDisplayValue(productType, t) : t("createProductDiscount.values.noVariants");
                                          })()}
                                    </div>
                                  </div>
                                ) : (
                                  <span className="text-sm break-words">
                                    {product.productName}
                                  </span>
                                )}
                              </div>
                            </div>
                          ),
                        },
                        {
                          key: "categoryName",
                          label: t("createProductDiscount.columns.category"),
                          sortable: false,
                        },
                        {
                          key: "vendors",
                          label: t("createProductDiscount.columns.vendorPrice"),
                          sortable: false,
                          align: "right" as const,
                          render: (product: any) => (
                            <div className="flex justify-end font-semibold text-right">
                              {getRetailPrices(product.vendors, "costPerUnit")}
                            </div>
                          ),
                        },
                        {
                          key: "prices",
                          sortable: false,
                          label: getPricingMode(cashDiscountConfig) === 'dual-pricing' ? t("createProductDiscount.columns.cardPrice") : t("createProductDiscount.columns.retailPrice"),
                          align: "right" as const,
                          render: (product: any) => (
                            <div className="flex justify-end font-semibold text-right">
                              {getRetailPrices(
                                product.prices,
                                "retailPriceExclTax"
                              )}
                            </div>
                          ),
                        },
                        ...(getPricingMode(cashDiscountConfig) !== 'retail-only' ? [{
                          key: "cashPrices",
                          sortable: false,
                          label: t("createProductDiscount.columns.cashPrice"),
                          align: "right" as const,
                          render: (product: any) => (
                            <div className="flex justify-end font-semibold text-right">
                              {getCashPriceDisplay(product.prices, cashDiscountConfig)}
                            </div>
                          ),
                        }] : []),
                        {
                          key: "prices",
                          sortable: false,
                          label: t("createProductDiscount.columns.discountedPrice"),
                          align: "right" as const,
                          render: (product: any) => {
                            const originalPrices = getRetailPriceInArray(
                              product.prices,
                              "retailPriceExclTax"
                            );

                            if (
                              !originalPrices ||
                              originalPrices.length === 0
                            ) {
                              return <div className="flex justify-end font-semibold text-right"><span>$0.00</span></div>;
                            }

                            return (
                              <div className="flex justify-end font-semibold text-right">
                                {discountTypeSpecialPricing &&
                                discountValueSpecialPricing > 0 ? (
                                  <>
                                    {originalPrices.length === 1 ? (
                                      <span>
                                        $
                                        {discountTypeSpecialPricing == 47
                                          ? formatCurrency(Math.max(
                                              originalPrices[0] -
                                                discountValueSpecialPricing,
                                              0
                                            ))
                                          : formatCurrency(
                                              originalPrices[0] *
                                              (1 -
                                                discountValueSpecialPricing /
                                                  100)
                                            )}
                                      </span>
                                    ) : (
                                      <span>
                                        $
                                        {discountTypeSpecialPricing == 47
                                          ? formatCurrency(Math.max(
                                              originalPrices[0] -
                                                discountValueSpecialPricing,
                                              0
                                            ))
                                          : formatCurrency(
                                              originalPrices[0] *
                                              (1 -
                                                discountValueSpecialPricing /
                                                  100)
                                            )}{" "}
                                        - $
                                        {discountTypeSpecialPricing == 47
                                          ? formatCurrency(Math.max(
                                              originalPrices[1] -
                                                discountValueSpecialPricing,
                                              0
                                            ))
                                          : formatCurrency(
                                              originalPrices[1] *
                                              (1 -
                                                discountValueSpecialPricing /
                                                  100)
                                            )}
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {originalPrices.length === 1 ? (
                                      <span>
                                        ${formatCurrency(originalPrices[0])}
                                      </span>
                                    ) : (
                                      <span>
                                        ${formatCurrency(originalPrices[0])} - $
                                        {formatCurrency(originalPrices[1])}
                                      </span>
                                    )}
                                  </>
                                )}
                              </div>
                            );
                          },
                        },
                        {
                          key: "inventoryLevels",
                          sortable: false,
                          label: t("createProductDiscount.columns.locationQtyInStock"),
                          render: (product: any) => {
                            const inventoryInfo =
                              inventoryDataSpecialPricing[product.id];

                            if (
                              !inventoryInfo ||
                              inventoryInfo.options.length === 0
                            ) {
                              return (
                                <span className="text-sm text-gray-500">
                                  {t("createProductDiscount.values.noStockData")}
                                </span>
                              );
                            }

                            const { options, displayText } = inventoryInfo;

                            // For display-only inventory, use SelectBox with read-only behavior
                            return (
                              <div className="min-w-[150px]">
                                <SelectBox
                                  value={options[0] || null} // Set first option as selected value
                                  onChange={() => {}} // Prevent changes - read-only behavior
                                  options={options}
                                  placeholder={displayText}
                                  className="!mb-0"
                                  size="sm"
                                  isClearable={false}
                                />
                              </div>
                            );
                          },
                        },
                        {
                          key: "active",
                          label: t("createProductDiscount.columns.active"),
                          sortable: false,
                          render: (product: any) => (
                            <div className="flex items-center gap-4">
                              <SwitchSlider
                                checked={product.isActive || false}
                                onChange={(checked) =>
                                  handleProductSelectionSpecialPricing(
                                    product,
                                    checked
                                  )
                                }
                                size="sm"
                              />
                              {!product.isVariant && (
                                <button
                                  className="p-1 text-red-500 hover:bg-red-50 rounded"
                                  type="button"
                                  title={t("common.actions.delete")}
                                  onClick={() =>
                                    confirm({
                                      type: "delete",
                                      title: t("createProductDiscount.deleteConfirm.title"),
                                      message: t("createProductDiscount.deleteConfirm.message", {
                                        name: product.name,
                                      }),
                                      onConfirm: () => confirmDeleteSpecialPricing(product),
                                    })
                                  }
                                >
                                  <Icon name="delete" className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>

                  {/* Discount Schedule */}
                  <div className="mt-6">
                    <div className={`border-b border-gray-300 pb-2 mb-6`}>
                      <h2 className="text-lg font-semibold mb-2 text-black">
                        {t("createProductDiscount.sections.discountSchedule")}
                      </h2>
                      <p className="mb-4 text-sm text-black"></p>
                    </div>

                    {/* Date Range */}
                    <div>
                      <div className="flex items-center gap-6 mb-6">
                        <div className="flex items-center gap-2">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer hidden"
                              {...control.register(
                                "SpecialPricing.isSetDateRange"
                              )}
                            />
                            <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                            <span className="ml-2 text-sm font-semibold text-black">
                              {t("createProductDiscount.toggles.setDateRange")}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div
                        className={`relative mb-6 ${
                          !isSetDateRangeWatchSpecialPricing
                            ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                            : ``
                        }`}
                      >
                        <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                          <div className="grid grid-cols-2 bg-[#e3e4e9] text-black text-sm font-medium">
                            <div className="px-2.5 py-4 border-r border-gray-100">
                              {t("createProductDiscount.schedule.period")}
                            </div>
                            <div className="px-2.5 py-4">{t("createProductDiscount.schedule.date")}</div>
                          </div>
                          <div className="grid grid-cols-2 border-t border-white">
                            <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                              {t("createProductDiscount.schedule.start")}
                            </div>
                            <div className="px-2.5 py-2">
                              <Controller
                                name="SpecialPricing.dateRanges.0.startDate"
                                control={control}
                                disabled={!isSetDateRangeWatchSpecialPricing}
                                render={({ field }) => (
                                  <div className="flex items-center">
                                    <div className="w-full grow">
                                      <DatePicker
                                        selected={field.value}
                                        onChange={(date) => {
                                          field.onChange(date);
                                          if (
                                            scheduleenddateWatchSpecialPricing &&
                                            moment(date).isAfter(
                                              moment(
                                                scheduleenddateWatchSpecialPricing
                                              )
                                            )
                                          ) {
                                            setValue(
                                              `SpecialPricing.dateRanges.0.endDate`,
                                              null
                                            );
                                          }
                                        }}
                                        icon={<Icon name="calendar" />}
                                        showIcon
                                        showYearDropdown
                                        dropdownMode="select"
                                        showMonthDropdown
                                        toggleCalendarOnIconClick
                                        placeholderText="MM/DD/YYYY"
                                        className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        wrapperClassName="w-full"
                                        calendarIconClassName={`right-0 text-gray-400 top-1`}
                                        dateFormat="MM/dd/YYYY"
                                        disabled={
                                          !isSetDateRangeWatchSpecialPricing
                                        }
                                        minDate={moment().toDate()}
                                      />
                                    </div>
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 border-t border-white">
                            <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                              {t("createProductDiscount.schedule.end")}
                            </div>
                            <div className="px-2.5 py-2">
                              <Controller
                                name="SpecialPricing.dateRanges.0.endDate"
                                control={control}
                                disabled={!isSetDateRangeWatchSpecialPricing}
                                render={({ field }) => (
                                  <div className="flex items-center">
                                    <div className="w-full grow">
                                      <DatePicker
                                        selected={field.value}
                                        onChange={(date) =>
                                          field.onChange(date)
                                        }
                                        showIcon
                                        showYearDropdown
                                        dropdownMode="select"
                                        showMonthDropdown
                                        icon={<Icon name="calendar" />}
                                        toggleCalendarOnIconClick
                                        placeholderText="MM/DD/YYYY"
                                        className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        wrapperClassName="w-full"
                                        calendarIconClassName={`right-0 text-gray-400 top-1`}
                                        dateFormat="MM/dd/YYYY"
                                        disabled={
                                          !isSetDateRangeWatchSpecialPricing
                                        }
                                        minDate={
                                          schedulestartdateWatchSpecialPricing &&
                                          typeof schedulestartdateWatchSpecialPricing !==
                                            `undefined` &&
                                          schedulestartdateWatchSpecialPricing
                                            ? moment(
                                                schedulestartdateWatchSpecialPricing
                                              ).toDate()
                                            : moment().toDate()
                                        }
                                      />
                                    </div>
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Weekly Schedule */}
                    <div>
                      <div className="flex items-center gap-6 mb-6">
                        <div className="flex items-center gap-2">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer hidden"
                              {...control.register(
                                "SpecialPricing.isSetSchedule"
                              )}
                            />
                            <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                            <span className="ml-2 text-sm font-semibold text-black">
                              {t("createProductDiscount.toggles.setSchedule")}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div
                        className={`relative mb-6 ${
                          !isSetScheduleWatchSpecialPricing
                            ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                            : ``
                        }`}
                      >
                        <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                          <div className="flex items-center bg-[#e3e4e9] text-black text-sm font-medium">
                            <div className="px-2.5 py-4 border-r border-gray-100 w-20"></div>
                            <div className="grid grid-cols-3 w-full">
                              <div className="px-2.5 py-4 border-r border-gray-100">
                                {t("createProductDiscount.schedule.days")}
                              </div>
                              <div className="px-2.5 py-4 border-r border-gray-100">
                                {t("createProductDiscount.schedule.startTime")}
                              </div>
                              <div className="px-2.5 py-4">{t("createProductDiscount.schedule.endTime")}</div>
                            </div>
                          </div>
                          {weeklySchedulesWatchSpecialPricing.map(
                            (wkschedule: any, index: number) => {
                              return (
                                <div
                                  className="flex items-center border-t border-white"
                                  key={`wk-` + index}
                                >
                                  <label className="px-2.5 py-2 w-20 bg-white border-r border-gray-300 flex justify-center items-center">
                                    <input
                                      type="checkbox"
                                      disabled={
                                        !isSetScheduleWatchSpecialPricing
                                      }
                                      {...control.register(
                                        `SpecialPricing.weeklySchedules.${index}.isActive`
                                      )}
                                    />
                                  </label>
                                  <div className="grid grid-cols-3 w-full">
                                    <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                                      {
                                        (dayNameObj as any)[
                                          wkschedule.dayOfWeek
                                        ]
                                      }
                                      {wkschedule.isActive && (
                                        <span className="text-red-600 ml-1">
                                          *
                                        </span>
                                      )}
                                    </div>
                                    <div className="px-2.5 py-2">
                                      <Controller
                                        name={`SpecialPricing.weeklySchedules.${index}.startTime`}
                                        control={control}
                                        disabled={
                                          !isSetScheduleWatchSpecialPricing ||
                                          !wkschedule.isActive
                                        }
                                        rules={
                                          wkschedule.isActive
                                            ? {
                                                required:
                                                  t("createProductDiscount.validation.startTimeRequired"),
                                              }
                                            : {}
                                        }
                                        render={({ field }) => (
                                          <div className="flex items-center">
                                            <div className="w-full grow">
                                              <DatePicker
                                                selected={field.value}
                                                onChange={(date) => {
                                                  field.onChange(date);
                                                  if (
                                                    wkschedule.endTime &&
                                                    date &&
                                                    moment(date).isSameOrAfter(
                                                      moment(wkschedule.endTime)
                                                    )
                                                  ) {
                                                    const startMoment = moment(date);
                                                    const maxEndTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                    let newEndTime = startMoment.clone().add(5, `minutes`);
                                                    
                                                    // Cap end time at 11:55 PM
                                                    if (newEndTime.isAfter(maxEndTime)) {
                                                      newEndTime = maxEndTime;
                                                    }
                                                    
                                                    setValue(
                                                      `SpecialPricing.weeklySchedules.${index}.endTime`,
                                                      newEndTime.toDate()
                                                    );
                                                  }
                                                }}
                                                icon={<Icon name="clock" />}
                                                showIcon
                                                toggleCalendarOnIconClick
                                                placeholderText="HH:MM"
                                                className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                wrapperClassName="w-full"
                                                calendarIconClassName={`right-0 text-gray-400 top-1`}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeIntervals={5}
                                                dateFormat="hh:mm aaaa"
                                                showTimeCaption={true}
                                                disabled={
                                                  !isSetScheduleWatchSpecialPricing ||
                                                  !wkschedule.isActive
                                                }
                                                minTime={moment(
                                                  moment().format(
                                                    `YYYY-MM-DD 00:00:00`
                                                  )
                                                ).toDate()}
                                                maxTime={moment(
                                                  moment().format(
                                                    `YYYY-MM-DD 23:50:00`
                                                  )
                                                ).toDate()}
                                                required={wkschedule.isActive}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      />
                                    </div>
                                    <div className="px-2.5 py-2">
                                      <Controller
                                        name={`SpecialPricing.weeklySchedules.${index}.endTime`}
                                        control={control}
                                        disabled={
                                          !isSetScheduleWatchSpecialPricing ||
                                          !wkschedule.isActive
                                        }
                                        rules={
                                          wkschedule.isActive
                                            ? {
                                                required:
                                                  t("createProductDiscount.validation.startTimeRequired"),
                                              }
                                            : {}
                                        }
                                        render={({ field }) => (
                                          <div className="flex items-center">
                                            <div className="w-full grow">
                                              <DatePicker
                                                selected={field.value}
                                                onChange={(date) =>
                                                  field.onChange(date)
                                                }
                                                icon={<Icon name="clock" />}
                                                showIcon
                                                toggleCalendarOnIconClick
                                                placeholderText="HH:MM"
                                                className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                wrapperClassName="w-full"
                                                calendarIconClassName={`right-0 text-gray-400 top-1`}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeIntervals={5}
                                                dateFormat="hh:mm aaaa"
                                                showTimeCaption={true}
                                                disabled={
                                                  !isSetScheduleWatchSpecialPricing ||
                                                  !wkschedule.isActive
                                                }
                                                minTime={
                                                  wkschedule.startTime &&
                                                  typeof wkschedule.startTime !==
                                                    `undefined` &&
                                                  wkschedule.startTime
                                                    ? (() => {
                                                        const minTime = moment(wkschedule.startTime).add(5, `minutes`);
                                                        const maxTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                        // If adding 5 minutes goes past 23:55, cap it at 23:55
                                                        return minTime.isAfter(maxTime) ? maxTime.toDate() : minTime.toDate();
                                                      })()
                                                    : moment(
                                                        moment().format(
                                                          `YYYY-MM-DD 00:00:00`
                                                        )
                                                      ).toDate()
                                                }
                                                maxTime={moment(
                                                  moment().format(
                                                    `YYYY-MM-DD 23:55:00`
                                                  )
                                                ).toDate()}
                                                required={wkschedule.isActive}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Discount Target */}
                  {/* Discount Target */}
                  <div className="mt-8">
                    <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                      <h2 className="text-lg font-semibold mb-2 text-black">
                        {t("createProductDiscount.sections.discountTarget")}
                      </h2>
                      <p className="mb-4 text-sm text-black">
                        {t("createProductDiscount.sections.discountTargetSubtitle")}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 gap-1 mb-6">
                      <label>
                        <input
                          type="radio"
                          className="hidden sr-only peer"
                          value={btoa(`139`)}
                          {...control.register(
                            "SpecialPricing.fkCustomerTargetTypeLookupValueId"
                          )}
                        />
                        <span
                          className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                        >
                          {t("createProductDiscount.target.allCustomers")}
                        </span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          className="hidden sr-only peer"
                          value={btoa(`140`)}
                          {...control.register(
                            "SpecialPricing.fkCustomerTargetTypeLookupValueId"
                          )}
                        />
                        <span
                          className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                        >
                          {t("createProductDiscount.target.specificGroups")}
                        </span>
                      </label>
                    </div>

                    {/* Customer Groups Dropdown - Only show when specific customer groups is selected */}
                    {fkCustomerTargetTypeLookupValueIdWatchSpecialPricing ===
                      btoa(`140`) && (
                      <div className="mb-6">
                        <CommonDropdown
                          control={control}
                          setValue={setValue}
                          rules={{
                            required: t("createProductDiscount.validation.customerGroupsRequired"),
                          }}
                          label={t("createProductDiscount.fields.customerGroups")}
                          name="SpecialPricing.customerGroups"
                          type="allCustomerGroups"
                          placeholder={t("createProductDiscount.placeholders.selectCustomerGroups")}
                          required={true}
                          isMulti={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              {activeTab == "Mix & Match Pricing" && (
                <div>
                  {/* General Section */}
                  <div>
                    <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                      <>
                        <h2 className="text-lg font-semibold mb-2 text-black">
                          {t("createProductDiscount.sections.general")}
                        </h2>
                        <p className="mb-4 text-sm text-black">
                          {t("createProductDiscount.sections.generalSubtitle")}
                        </p>
                      </>
                    </div>
                    <div className="grid grid-cols-1 gap-6 mb-6">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-normal text-black flex items-center gap-1">
                          {t("createProductDiscount.toggles.manual")}
                          <span className="cursor-pointer text-secondary"><Icon name="info" size={16} title={t("createProductDiscount.toggles.manualInfo")} /></span>
                        </span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer hidden"
                            {...control.register("MixAndMatch.isAutomatic")}
                          />
                          <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                          <span className="ml-2 text-sm font-normal text-black">
                            {t("createProductDiscount.toggles.automatic")}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                      <div>
                        <Controller
                          name="MixAndMatch.discountName"
                          control={control}
                          rules={{
                            required: t("createProductDiscount.validation.nameRequired"),
                            validate: (value: string) =>
                              value?.trim().length > 0 || t("createProductDiscount.validation.nameRequired"),
                          }}
                          render={({ field, fieldState }) => (
                            <Input
                              {...field}
                              className="!my-0 !mb-6"
                              type="text"
                              label={t("createProductDiscount.fields.discountCode")}
                              required
                              placeholder={t("createProductDiscount.placeholders.enterDiscountCode")}
                              error={fieldState.error?.message}
                            />
                          )}
                        />
                        <div>
                          <CommonDropdown
                            control={control}
                            setValue={setValue}
                            rules={{ required: t("createProductDiscount.validation.locationRequired") }}
                            label={t("createProductDiscount.fields.location")}
                            name="MixAndMatch.locations"
                            type="location"
                            placeholder={t("createProductDiscount.placeholders.selectLocation")}
                            required={true}
                            isMulti={true}
                          />
                        </div>
                      </div>
                      <Controller
                        name="MixAndMatch.discountDescription"
                        control={control}
                        render={({ field, fieldState }) => (
                          <Textarea
                            {...field}
                            className="!my-0 w-full"
                            mainElementClassName={`h-[132px]`}
                            label={t("createProductDiscount.fields.discountDescription")}
                            placeholder={t("createProductDiscount.placeholders.description")}
                            error={fieldState.error?.message}
                          />
                        )}
                      />
                    </div>
                  </div>

                  {/* Discount Rule Section */}
                  <div>
                    <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                      <h2 className="text-lg font-semibold mb-2 text-black">
                        {t("productDiscount.sections.discountRule")}
                      </h2>
                      <p className="mb-4 text-sm text-black">
                        {t("productDiscount.sections.discountRuleSubtitle")}
                      </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-0">
                        <div>
                          <CommonDropdown
                            preSelectValues={"48"}
                            control={control}
                            setValue={setValue}
                            label={t("createProductDiscount.fields.discountType")}
                            name="MixAndMatch.rules.0.fkDiscountValueTypeLookupValueId"
                            type="lookup"
                            placeholder={t("createProductDiscount.placeholders.selectDiscountType")}
                            required
                            rules={{ required: t("createProductDiscount.validation.discountTypeRequired") }}
                            data={lookup.getDiscountType()}
                          />
                        </div>
                        <Controller
                          name="MixAndMatch.rules.0.discountValue"
                          control={control}
                          rules={{
                            required: t("createProductDiscount.validation.discountValueRequired"),
                            validate: (value) => {
                              const numValue = Number(value);
                              const discountTypeValue = discountTypeMixAndMatch; // This is from watch()

                              // Check if it's a valid number
                              if (isNaN(numValue)) {
                                return t("createProductDiscount.validation.discountValueInvalid");
                              }

                              // Fixed amount discount (assuming ID 47 is fixed amount)
                              if (discountTypeValue == 47) {
                                if (numValue < 0) {
                                  return t("createProductDiscount.validation.fixedDiscountMin");
                                }
                                if (numValue > 1000) {
                                  return t("createProductDiscount.validation.fixedDiscountMax");
                                }
                              }
                              // Percentage discount (assuming other IDs are percentage)
                              else {
                                if (numValue < 0) {
                                  return t("createProductDiscount.validation.percentDiscountMin");
                                }
                                if (numValue > 100) {
                                  return t("createProductDiscount.validation.percentDiscountMax");
                                }
                              }

                              return true;
                            },
                          }}
                          render={({ field, fieldState }) => (
                            <DecimalInput
                              value={field.value}
                              onChange={field.onChange}
                              decimalPlaces={2}
                              min={0}
                              max={discountTypeMixAndMatch == 47 ? 9999999999 : 100}
                              className="!my-0 !mb-6"
                              label={t("createProductDiscount.fields.discountValue")}
                              placeholder="0"
                              required
                              withDollarIcon={discountTypeMixAndMatch == 47}
                              error={fieldState.error?.message as any}
                            />
                          )}
                        />
                        <div>
                          <Label text={t("createProductDiscount.labels.minimumRequirement.text")} info={t("createProductDiscount.labels.minimumRequirement.info")} required />
                          <CommonDropdown
                            control={control}
                            setValue={setValue}
                            label=""
                            name="MixAndMatch.rules.0.fkMinimumRequirementTypeLookupValueId"
                            type="lookup"
                            placeholder={t("createProductDiscount.placeholders.minimumRequirements")}
                            required
                            rules={{
                              required:
                                t("createProductDiscount.validation.minimumPurchaseRequirementRequired"),
                            }}
                            data={lookup.getDiscountMinPurchaseAmount()}
                            labelisElipsis={true}
                          />
                        </div>
                        <Controller
                          name="MixAndMatch.rules.0.minPurchaseQty"
                          control={control}
                          rules={
                            (ui_minrequirementtyopevaluesMixAndMatch as any)
                              ?.value == 126
                              ? {
                                  required: t("createProductDiscount.validation.minPurchaseAmountRequired"),
                                  validate: (value) => {
                                    const numValue = Number(value);
                                    if (isNaN(numValue)) {
                                      return t("createProductDiscount.validation.maxAllowedQtyInvalid");
                                    }
                                    if (numValue < 1) {
                                      return t("createProductDiscount.validation.maxAllowedQtyMin");
                                    }
                                    return true;
                                  },
                                }
                              : {}
                          }
                          disabled={
                            (ui_minrequirementtyopevaluesMixAndMatch as any)
                              ?.value === 125
                          }
                          render={({ field, fieldState }) => (
                            <div>
                              <Label text={t("createProductDiscount.labels.minPurchaseQty.text")} info={t("createProductDiscount.labels.minPurchaseQty.info")} />
                              <DecimalInput
                                value={field.value}
                                onChange={field.onChange}
                                fieldType="unit" // restricts to whole numbers
                                min={0}
                                max={9999999999}
                                labelSpaceNeeded
                                className="!my-0 !mb-6"
                                disabled={
                                  (ui_minrequirementtyopevaluesMixAndMatch as any)
                                    ?.value === 125
                                }
                                label=""
                                placeholder="0"
                                required={
                                  (ui_minrequirementtyopevaluesMixAndMatch as any)
                                    ?.value == 126
                                }
                                error={fieldState.error?.message}
                              />
                            </div>
                          )}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-0">
                      <div>
                        <Label text={t("createProductDiscount.labels.maximumAllowed.text")} info={t("createProductDiscount.labels.maximumAllowed.info")} required />
                        <CommonDropdown
                          control={control}
                          setValue={setValue}
                          label=""
                          name="MixAndMatch.rules.0.fkMaxLimitTypeLookupValueId"
                          type="lookup"
                          placeholder={t("createProductDiscount.labels.maximumAllowed.text")}
                          required
                          rules={{ required: t("createProductDiscount.validation.maximumAllowedRequired") }}
                          data={lookup.getDiscountMaxAllowed()}
                          labelisElipsis={true}
                        />
                      </div>
                      <Controller
                        name="MixAndMatch.rules.0.maxAllowedQty"
                        control={control}
                        rules={
                          (ui_maxLimitTypeWatchMixAndMatch as any)?.value ==
                          128
                            ? {
                                required: t("createProductDiscount.validation.minPurchaseAmountRequired"),
                                validate: (value) => {
                                  const numValue = Number(value);
                                  if (isNaN(numValue)) {
                                    return t("createProductDiscount.validation.maxAllowedQtyInvalid");
                                  }
                                  if (numValue < 1) {
                                    return t("createProductDiscount.validation.maxAllowedQtyMin");
                                  }
                                  return true;
                                },
                              }
                            : {}
                        }
                        disabled={
                          (ui_maxLimitTypeWatchMixAndMatch as any)?.value ===
                          127
                        }
                        render={({ field, fieldState }) => (
                          <div>
                            <Label text={t("createProductDiscount.labels.maxAllowedQty.text")} info={t("createProductDiscount.labels.maxAllowedQty.info")} />
                            <DecimalInput
                              value={field.value ?? undefined}
                              onChange={field.onChange}
                              fieldType="unit" // restricts to whole numbers
                              min={0}
                              max={9999999999}
                              labelSpaceNeeded
                              className="!my-0 !mb-6"
                              label=""
                              placeholder=""
                              disabled={
                                (ui_maxLimitTypeWatchMixAndMatch as any)
                                  ?.value === 127
                              }
                              required={
                                (ui_maxLimitTypeWatchMixAndMatch as any)
                                  ?.value == 128
                              }
                              error={fieldState.error?.message}
                            />
                          </div>
                        )}
                      />
                      <div>
                        <Label text={t("createProductDiscount.labels.discountUsageLimit.text")} info={t("createProductDiscount.labels.discountUsageLimit.infoMixAndMatch")} required />
                        <CommonDropdown
                          control={control}
                          setValue={setValue}
                          label=""
                          name="MixAndMatch.ui_maxdiscountallowed"
                          type="lookup"
                          placeholder={t("createProductDiscount.placeholders.maximumDiscountUser")}
                          required
                          rules={{
                            required: t("createProductDiscount.validation.maximumDiscountUserRequired"),
                          }}
                          data={lookup.getDiscountUsageLimit()}
                        />
                      </div>
                      <Controller
                        name="MixAndMatch.rules.0.totalUsageLimit"
                        control={control}
                        rules={
                          (ui_maxdiscountallowedWatchMixAndMatch as any) &&
                          (ui_maxdiscountallowedWatchMixAndMatch as any)
                            ?.value !== 130
                            ? {
                                required: t("createProductDiscount.validation.totalUsageLimitRequired"),
                                validate: (value) => {
                                  const numValue = Number(value);
                                  if (isNaN(numValue)) {
                                    return t("createProductDiscount.validation.maximumDiscountUsageInvalid");
                                  }
                                  if (numValue < 1) {
                                    return t("createProductDiscount.validation.maximumDiscountUsageMin");
                                  }
                                  return true;
                                },
                              }
                            : {}
                        }
                        disabled={
                          (ui_maxdiscountallowedWatchMixAndMatch as any) &&
                          (ui_maxdiscountallowedWatchMixAndMatch as any)
                            ?.value === 130
                        }
                        render={({ field, fieldState }) => (
                          <DecimalInput
                            value={field.value}
                            onChange={field.onChange}
                            fieldType="unit"
                            min={0}
                            max={9999999999}
                            className="!my-0 !mb-6"
                            label={t("createProductDiscount.fields.discountUsageLimitValue")}
                            placeholder="0"
                            disabled={
                              (ui_maxdiscountallowedWatchMixAndMatch as any) &&
                              (ui_maxdiscountallowedWatchMixAndMatch as any)
                                ?.value === 130
                            }
                            required={
                              (ui_maxdiscountallowedWatchMixAndMatch as any) &&
                              (ui_maxdiscountallowedWatchMixAndMatch as any)
                                ?.value !== 130
                            }
                            error={fieldState.error?.message}
                          />
                        )}
                      />
                    </div>
                    {/* <div className="mb-8">
                      <div className="flex items-center gap-1" title="This product discount can be combined with">
                        <Label text="Combinations" />
                        <Icon name="info" className=" text-secondary cursor-pointer" title="This product discount can be combined with"/>
                      </div>
                      <SelectBox
                        value={discountCombinationsMixAndMatch}
                        onChange={(selectedOptions: any) => {
                          setDiscountCombinationsMixAndMatch(
                            selectedOptions || []
                          );
                        }}
                        options={
                          lookup.getDiscountCombination()?.map((item: any) => ({
                            label: item.lookupValue,
                            value: item.lookupId,
                          })) || []
                        }
                        placeholder="Select Combinations"
                        isMulti={true}
                        className="w-full !my-0"
                        isClearable={true}
                      />
                    </div> */}
                  </div>
                  <div className="flex justify-between items-center w-full">
                    <div className="w-1/3">
                      <CommonDropdown
                        control={control}
                        setValue={setValue}
                        label={t("createProductDiscount.fields.selectProductsCategory")}
                        name="MixAndMatch.productCategory"
                        type="categorytreebind"
                        className="!my-0"
                        placeholder={t("createProductDiscount.placeholders.selectCategory")}
                        // required
                        disabled={categoryDisabledMixAndMatch}
                        isMulti={true}
                      />
                    </div>

                    <div className="flex items-center gap-2">
                      <Button
                        type="button"
                        theme="secondary"
                        onClick={() => {
                          const selectedLocations = getValues("MixAndMatch.locations");
                          if (!selectedLocations || selectedLocations.length === 0) {
                            toast.error(t("createProductDiscount.validation.selectLocationFirst"));
                            return;
                          }
                          setShowSelectAllModal(true);
                        }}
                      >
                        {t("createProductDiscount.buttons.selectAllProducts")}
                      </Button>

                      <Button
                        type="button"
                        onClick={() => {
                          const selectedLocations = getValues("MixAndMatch.locations");
                          if (!selectedLocations || selectedLocations.length === 0) {
                            toast.error(t("createProductDiscount.validation.selectLocationFirst"));
                            return;
                          }
                          setShowAddDiscountModal(true);
                        }}
                      >
                        {t("createProductDiscount.buttons.searchProduct")}
                      </Button>
                    </div>

                    {showAddDiscountModal && (
                      <SiteModal
                        modalWidth={1000}
                        width={true}
                        // className="mt-20"
                        isOpen={showAddDiscountModal}
                        onClose={closeAddDiscountModal}
                        title={t("createProductDiscount.modal.selectProductsTitle")}
                        isBlur={true}
                        closeOnBackdrop={false}
                      >
                        <ProductSearchModal
                          category={getValues(`MixAndMatch.productCategory`) || []}
                          location={getValues("MixAndMatch.locations") || []}
                          onClose={closeAddDiscountModal}
                          onConfirm={searchConfirmMixAndMatch}
                          productData={productDataMixAndMatch}
                          disableCategory={true}
                          hideCategory={false}
                        ></ProductSearchModal>
                      </SiteModal>
                    )}

                    {showSelectAllModal && (
                      <SiteModal
                        modalWidth={1000}
                        width={true}
                        isOpen={showSelectAllModal}
                        onClose={closeSelectAllModal}
                        title={t("createProductDiscount.modal.selectProductsTitle")}
                        isBlur={true}
                        closeOnBackdrop={false}
                      >
                        <ProductSearchModalAll
                          category={getValues(`MixAndMatch.productCategory`) || []}
                          location={getValues("MixAndMatch.locations") || []}
                          onClose={closeSelectAllModal}
                          onConfirm={(selected: any) => {
                            searchConfirmMixAndMatch(selected);
                            setShowSelectAllModal(false);
                          }}
                          productData={productDataMixAndMatch}
                          disableCategory={true}
                          hideCategory={false}
                        ></ProductSearchModalAll>
                      </SiteModal>
                    )}
                  </div>

                  <div className="mt-6">
                    <ReusableTable
                      paddingBottomNeeded={
                        productDataTreeMixAndMatch?.length > 0
                      }
                      fixedHeight="calc(100vh - 200px)"
                      data={getVisibleProductsMixAndMatch()}
                      enableExpand={false}
                      columns={[
                        {
                          key: "productName",
                          label: t("createProductDiscount.columns.productName"),
                          sortable: false,
                          render: (product: any) => (
                            <div className="flex items-center gap-2">
                              {/* Indentation for tree structure */}
                              <div
                                style={{ marginLeft: product.level * 20 }}
                                className="flex items-center gap-2"
                              >
                                {/* Expand/Collapse button for products with variants */}
                                {product.hasChildren && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleToggleExpandMixAndMatch(
                                        product.productId
                                      )
                                    }
                                    className="w-6 h-6 flex cursor-pointer items-center justify-center text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
                                  >
                                    <Icon
                                      name={
                                        expandedProductsMixAndMatch.has(
                                          product.productId
                                        )
                                          ? "arrowdown"
                                          : "arrowright"
                                      }
                                      className="w-4 h-4"
                                    />
                                  </button>
                                )}
                                {!product.hasChildren &&
                                  product.level === 0 && (
                                    <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                      {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                                    </div>
                                  )}
                                {!product.hasChildren && product.level > 0 && (
                                  <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                    {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                                  </div>
                                )}

                                {/* Product name */}
                                {!product.isVariant ? (
                                  <div>
                                    <div className="font-medium">
                                      {product.productName}
                                    </div>
                                    <div className="border-b-2 border-black my-1"></div>
                                    <div className="text-sm text-gray-500">
                                      {product.hasChildren
                                        ? t("createProductDiscount.values.variantsCount", {
                                            count: productDataTreeMixAndMatch?.filter(
                                              (p: any) =>
                                                p.isVariant &&
                                                p.parentId === product.productId
                                            ).length,
                                          })
                                        : (() => {
                                            const productType = lookup.getProductType()?.find(
                                              (type: any) => btoa(type?.lookupId) === product?.fkProductTypeLookupValueId
                                            );
                                            return productType ? getLookupDisplayValue(productType, t) : t("createProductDiscount.values.noVariants");
                                          })()}
                                    </div>
                                  </div>
                                ) : (
                                  <span className="text-sm break-words">
                                    {product.productName}
                                  </span>
                                )}
                              </div>
                            </div>
                          ),
                        },
                        {
                          key: "categoryName",
                          label: t("createProductDiscount.columns.category"),
                          sortable: false,
                        },
                        {
                          key: "vendors",
                          label: t("createProductDiscount.columns.vendorPrice"),
                          sortable: false,
                          align: "right" as const,
                          render: (product: any) => (
                            <div className="flex justify-end font-semibold text-right">
                              {getRetailPrices(product.vendors, "costPerUnit")}
                            </div>
                          ),
                        },
                        {
                          key: "prices",
                          sortable: false,
                          label: getPricingMode(cashDiscountConfig) === 'dual-pricing' ? t("createProductDiscount.columns.cardPrice") : t("createProductDiscount.columns.retailPrice"),
                          align: "right" as const,
                          render: (product: any) => (
                            <div className="flex justify-end font-semibold text-right">
                              {getRetailPrices(
                                product.prices,
                                "retailPriceExclTax"
                              )}
                            </div>
                          ),
                        },
                        ...(getPricingMode(cashDiscountConfig) !== 'retail-only' ? [{
                          key: "cashPrices",
                          sortable: false,
                          label: t("createProductDiscount.columns.cashPrice"),
                          align: "right" as const,
                          render: (product: any) => (
                            <div className="flex justify-end font-semibold text-right">
                              {getCashPriceDisplay(product.prices, cashDiscountConfig)}
                            </div>
                          ),
                        }] : []),
                        {
                          key: "prices",
                          sortable: false,
                          label: t("createProductDiscount.columns.discountedPrice"),
                          align: "right" as const,
                          render: (product: any) => {
                            const originalPrices = getRetailPriceInArray(
                              product.prices,
                              "retailPriceExclTax"
                            );

                            if (
                              !originalPrices ||
                              originalPrices.length === 0
                            ) {
                              return <div className="flex justify-end font-semibold text-right"><span>$0.00</span></div>;
                            }

                            return (
                              <div className="flex justify-end font-semibold text-right">
                                {discountTypeMixAndMatch &&
                                discountValueMixAndMatch > 0 ? (
                                  <>
                                    {originalPrices.length === 1 ? (
                                      <span>
                                        $
                                        {discountTypeMixAndMatch == 47
                                          ? formatCurrency(Math.max(
                                              originalPrices[0] -
                                                discountValueMixAndMatch,
                                              0
                                            ))
                                          : formatCurrency(
                                              originalPrices[0] *
                                              (1 -
                                                discountValueMixAndMatch / 100)
                                            )}
                                      </span>
                                    ) : (
                                      <span>
                                        $
                                        {discountTypeMixAndMatch == 47
                                          ? formatCurrency(Math.max(
                                              originalPrices[0] -
                                                discountValueMixAndMatch,
                                              0
                                            ))
                                          : formatCurrency(
                                              originalPrices[0] *
                                              (1 -
                                                discountValueMixAndMatch / 100)
                                            )}{" "}
                                        - $
                                        {discountTypeMixAndMatch == 47
                                          ? formatCurrency(Math.max(
                                              originalPrices[1] -
                                                discountValueMixAndMatch,
                                              0
                                            ))
                                          : formatCurrency(
                                              originalPrices[1] *
                                              (1 -
                                                discountValueMixAndMatch / 100)
                                            )}
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {originalPrices.length === 1 ? (
                                      <span>
                                        ${formatCurrency(originalPrices[0])}
                                      </span>
                                    ) : (
                                      <span>
                                        ${formatCurrency(originalPrices[0])} - $
                                        {formatCurrency(originalPrices[1])}
                                      </span>
                                    )}
                                  </>
                                )}
                              </div>
                            );
                          },
                        },
                        {
                          key: "inventoryLevels",
                          sortable: false,
                          label: t("createProductDiscount.columns.locationQtyInStock"),
                          render: (product: any) => {
                            const inventoryInfo =
                              inventoryDataMixAndMatch[product.id];

                            if (
                              !inventoryInfo ||
                              inventoryInfo.options.length === 0
                            ) {
                              return (
                                <span className="text-sm text-gray-500">
                                  {t("createProductDiscount.values.noStockData")}
                                </span>
                              );
                            }

                            const { options, displayText } = inventoryInfo;

                            // For display-only inventory, use SelectBox with read-only behavior
                            return (
                              <div className="min-w-[150px]">
                                <SelectBox
                                  value={options[0] || null} // Set first option as selected value
                                  onChange={() => {}} // Prevent changes - read-only behavior
                                  options={options}
                                  placeholder={displayText}
                                  className="!mb-0"
                                  size="sm"
                                  isClearable={false}
                                />
                              </div>
                            );
                          },
                        },
                        {
                          key: "active",
                          label: t("createProductDiscount.columns.active"),
                          sortable: false,
                          render: (product: any) => (
                            <div className="flex items-center gap-4">
                              <SwitchSlider
                                checked={product.isActive || false}
                                onChange={(checked) =>
                                  handleProductSelectionMixAndMatch(
                                    product,
                                    checked
                                  )
                                }
                                size="sm"
                              />
                              {!product.isVariant && (
                                <button
                                  className="p-1 text-red-500 hover:bg-red-50 rounded"
                                  type="button"
                                  title={t("common.actions.delete")}
                                  onClick={() =>
                                    confirm({
                                      type: "delete",
                                      title: t("createProductDiscount.deleteConfirm.title"),
                                      message: t("createProductDiscount.deleteConfirm.message", {
                                        name: product.name,
                                      }),
                                      onConfirm: () => confirmDeleteMixAndMatch(product),
                                    })
                                  }
                                >
                                  <Icon name="delete" className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>

                  {/* Discount Schedule */}
                  <div className="mt-6">
                    <div className={`border-b border-gray-300 pb-2 mb-6`}>
                      <h2 className="text-lg font-semibold mb-2 text-black">
                        {t("createProductDiscount.sections.discountSchedule")}
                      </h2>
                      <p className="mb-4 text-sm text-black"></p>
                    </div>

                    {/* Date Range */}
                    <div>
                      <div className="flex items-center gap-6 mb-6">
                        <div className="flex items-center gap-2">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer hidden"
                              {...control.register(
                                "MixAndMatch.isSetDateRange"
                              )}
                            />
                            <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                            <span className="ml-2 text-sm font-semibold text-black">
                              {t("createProductDiscount.toggles.setDateRange")}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div
                        className={`relative mb-6 ${
                          !isSetDateRangeWatchMixAndMatch
                            ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                            : ``
                        }`}
                      >
                        <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                          <div className="grid grid-cols-2 bg-[#e3e4e9] text-black text-sm font-medium">
                            <div className="px-2.5 py-4 border-r border-gray-100">
                              {t("createProductDiscount.schedule.period")}
                            </div>
                            <div className="px-2.5 py-4">{t("createProductDiscount.schedule.date")}</div>
                          </div>
                          <div className="grid grid-cols-2 border-t border-white">
                            <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                              {t("createProductDiscount.schedule.start")}
                            </div>
                            <div className="px-2.5 py-2">
                              <Controller
                                name="MixAndMatch.dateRanges.0.startDate"
                                control={control}
                                disabled={!isSetDateRangeWatchMixAndMatch}
                                render={({ field }) => (
                                  <div className="flex items-center">
                                    <div className="w-full grow">
                                      <DatePicker
                                        selected={field.value}
                                        onChange={(date) => {
                                          field.onChange(date);
                                          if (
                                            scheduleenddateWatchMixAndMatch &&
                                            moment(date).isAfter(
                                              moment(
                                                scheduleenddateWatchMixAndMatch
                                              )
                                            )
                                          ) {
                                            setValue(
                                              `MixAndMatch.dateRanges.0.endDate`,
                                              null
                                            );
                                          }
                                        }}
                                        icon={<Icon name="calendar" />}
                                        showIcon
                                        showYearDropdown
                                        dropdownMode="select"
                                        showMonthDropdown
                                        toggleCalendarOnIconClick
                                        placeholderText="MM/DD/YYYY"
                                        className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        wrapperClassName="w-full"
                                        calendarIconClassName={`right-0 text-gray-400 top-1`}
                                        dateFormat="MM/dd/YYYY"
                                        disabled={
                                          !isSetDateRangeWatchMixAndMatch
                                        }
                                        minDate={moment().toDate()}
                                      />
                                    </div>
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 border-t border-white">
                            <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                              {t("createProductDiscount.schedule.end")}
                            </div>
                            <div className="px-2.5 py-2">
                              <Controller
                                name="MixAndMatch.dateRanges.0.endDate"
                                control={control}
                                disabled={!isSetDateRangeWatchMixAndMatch}
                                render={({ field }) => (
                                  <div className="flex items-center">
                                    <div className="w-full grow">
                                      <DatePicker
                                        selected={field.value}
                                        onChange={(date) =>
                                          field.onChange(date)
                                        }
                                        showIcon
                                        showYearDropdown
                                        dropdownMode="select"
                                        showMonthDropdown
                                        icon={<Icon name="calendar" />}
                                        toggleCalendarOnIconClick
                                        placeholderText="MM/DD/YYYY"
                                        className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        wrapperClassName="w-full"
                                        calendarIconClassName={`right-0 text-gray-400 top-1`}
                                        dateFormat="MM/dd/YYYY"
                                        disabled={
                                          !isSetDateRangeWatchMixAndMatch
                                        }
                                        minDate={
                                          schedulestartdateWatchMixAndMatch &&
                                          typeof schedulestartdateWatchMixAndMatch !==
                                            `undefined` &&
                                          schedulestartdateWatchMixAndMatch
                                            ? moment(
                                                schedulestartdateWatchMixAndMatch
                                              ).toDate()
                                            : moment().toDate()
                                        }
                                      />
                                    </div>
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Weekly Schedule */}
                    <div>
                      <div className="flex items-center gap-6 mb-6">
                        <div className="flex items-center gap-2">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer hidden"
                              {...control.register("MixAndMatch.isSetSchedule")}
                            />
                            <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                            <span className="ml-2 text-sm font-semibold text-black">
                              {t("createProductDiscount.toggles.setSchedule")}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div
                        className={`relative mb-6 ${
                          !isSetScheduleWatchMixAndMatch
                            ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                            : ``
                        }`}
                      >
                        <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                          <div className="flex items-center bg-[#e3e4e9] text-black text-sm font-medium">
                            <div className="px-2.5 py-4 border-r border-gray-100 w-20"></div>
                            <div className="grid grid-cols-3 w-full">
                              <div className="px-2.5 py-4 border-r border-gray-100">
                                {t("createProductDiscount.schedule.days")}
                              </div>
                              <div className="px-2.5 py-4 border-r border-gray-100">
                                {t("createProductDiscount.schedule.startTime")}
                              </div>
                              <div className="px-2.5 py-4">{t("createProductDiscount.schedule.endTime")}</div>
                            </div>
                          </div>
                          {weeklySchedulesWatchMixAndMatch.map(
                            (wkschedule: any, index: number) => {
                              return (
                                <div
                                  className="flex items-center border-t border-white"
                                  key={`wk-` + index}
                                >
                                  <label className="px-2.5 py-2 w-20 bg-white border-r border-gray-300 flex justify-center items-center">
                                    <input
                                      type="checkbox"
                                      disabled={!isSetScheduleWatchMixAndMatch}
                                      {...control.register(
                                        `MixAndMatch.weeklySchedules.${index}.isActive`
                                      )}
                                    />
                                  </label>
                                  <div className="grid grid-cols-3 w-full">
                                    <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                                      {
                                        (dayNameObj as any)[
                                          wkschedule.dayOfWeek
                                        ]
                                      }
                                      {wkschedule.isActive && (
                                        <span className="text-red-600 ml-1">
                                          *
                                        </span>
                                      )}
                                    </div>
                                    <div className="px-2.5 py-2">
                                      <Controller
                                        name={`MixAndMatch.weeklySchedules.${index}.startTime`}
                                        control={control}
                                        disabled={
                                          !isSetScheduleWatchMixAndMatch ||
                                          !wkschedule.isActive
                                        }
                                        rules={
                                          wkschedule.isActive
                                            ? {
                                                required:
                                                  t("createProductDiscount.validation.startTimeRequired"),
                                              }
                                            : {}
                                        }
                                        render={({ field }) => (
                                          <div className="flex items-center">
                                            <div className="w-full grow">
                                              <DatePicker
                                                selected={field.value}
                                                onChange={(date) => {
                                                  field.onChange(date);
                                                  if (
                                                    wkschedule.endTime &&
                                                    date &&
                                                    moment(date).isSameOrAfter(
                                                      moment(wkschedule.endTime)
                                                    )
                                                  ) {
                                                    const startMoment = moment(date);
                                                    const maxEndTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                    let newEndTime = startMoment.clone().add(5, `minutes`);
                                                    
                                                    // Cap end time at 11:55 PM
                                                    if (newEndTime.isAfter(maxEndTime)) {
                                                      newEndTime = maxEndTime;
                                                    }
                                                    
                                                    setValue(
                                                      `MixAndMatch.weeklySchedules.${index}.endTime`,
                                                      newEndTime.toDate()
                                                    );
                                                  }
                                                }}
                                                icon={<Icon name="clock" />}
                                                showIcon
                                                toggleCalendarOnIconClick
                                                placeholderText="HH:MM"
                                                className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                wrapperClassName="w-full"
                                                calendarIconClassName={`right-0 text-gray-400 top-1`}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeIntervals={5}
                                                dateFormat="hh:mm aaaa"
                                                showTimeCaption={true}
                                                disabled={
                                                  !isSetScheduleWatchMixAndMatch ||
                                                  !wkschedule.isActive
                                                }
                                                minTime={moment(
                                                  moment().format(
                                                    `YYYY-MM-DD 00:00:00`
                                                  )
                                                ).toDate()}
                                                maxTime={moment(
                                                  moment().format(
                                                    `YYYY-MM-DD 23:50:00`
                                                  )
                                                ).toDate()}
                                                required={wkschedule.isActive}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      />
                                    </div>
                                    <div className="px-2.5 py-2">
                                      <Controller
                                        name={`MixAndMatch.weeklySchedules.${index}.endTime`}
                                        control={control}
                                        disabled={
                                          !isSetScheduleWatchMixAndMatch ||
                                          !wkschedule.isActive
                                        }
                                        rules={
                                          wkschedule.isActive
                                            ? {
                                                required:
                                                  t("createProductDiscount.validation.startTimeRequired"),
                                              }
                                            : {}
                                        }
                                        render={({ field }) => (
                                          <div className="flex items-center">
                                            <div className="w-full grow">
                                              <DatePicker
                                                selected={field.value}
                                                onChange={(date) =>
                                                  field.onChange(date)
                                                }
                                                icon={<Icon name="clock" />}
                                                showIcon
                                                toggleCalendarOnIconClick
                                                placeholderText="HH:MM"
                                                className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                wrapperClassName="w-full"
                                                calendarIconClassName={`right-0 text-gray-400 top-1`}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeIntervals={5}
                                                dateFormat="hh:mm aaaa"
                                                showTimeCaption={true}
                                                disabled={
                                                  !isSetScheduleWatchMixAndMatch ||
                                                  !wkschedule.isActive
                                                }
                                                minTime={
                                                  wkschedule.startTime &&
                                                  typeof wkschedule.startTime !==
                                                    `undefined` &&
                                                  wkschedule.startTime
                                                    ? (() => {
                                                        const minTime = moment(wkschedule.startTime).add(5, `minutes`);
                                                        const maxTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                        // If adding 5 minutes goes past 23:55, cap it at 23:55
                                                        return minTime.isAfter(maxTime) ? maxTime.toDate() : minTime.toDate();
                                                      })()
                                                    : moment(
                                                        moment().format(
                                                          `YYYY-MM-DD 00:00:00`
                                                        )
                                                      ).toDate()
                                                }
                                                maxTime={moment(
                                                  moment().format(
                                                    `YYYY-MM-DD 23:55:00`
                                                  )
                                                ).toDate()}
                                                required={wkschedule.isActive}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Discount Target */}
                  {/* Discount Target */}
                  <div className="mt-8">
                    <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                      <h2 className="text-lg font-semibold mb-2 text-black">
                        {t("createProductDiscount.sections.discountTarget")}
                      </h2>
                      <p className="mb-4 text-sm text-black">
                        {t("createProductDiscount.sections.discountTargetSubtitle")}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 gap-1 mb-6">
                      <label>
                        <input
                          type="radio"
                          className="hidden sr-only peer"
                          value={btoa(`139`)}
                          {...control.register(
                            "MixAndMatch.fkCustomerTargetTypeLookupValueId"
                          )}
                        />
                        <span
                          className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                        >
                          {t("createProductDiscount.target.allCustomers")}
                        </span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          className="hidden sr-only peer"
                          value={btoa(`140`)}
                          {...control.register(
                            "MixAndMatch.fkCustomerTargetTypeLookupValueId"
                          )}
                        />
                        <span
                          className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                        >
                          {t("createProductDiscount.target.specificGroups")}
                        </span>
                      </label>
                    </div>

                    {/* Customer Groups Dropdown - Only show when specific customer groups is selected */}
                    {fkCustomerTargetTypeLookupValueIdWatchMixAndMatch ===
                      btoa(`140`) && (
                      <div className="mb-6">
                        <CommonDropdown
                          control={control}
                          setValue={setValue}
                          rules={{
                            required: t("createProductDiscount.validation.customerGroupsRequired"),
                          }}
                          label={t("createProductDiscount.fields.customerGroups")}
                          name="MixAndMatch.customerGroups"
                          type="allCustomerGroups"
                          placeholder={t("createProductDiscount.placeholders.selectCustomerGroups")}
                          required={true}
                          isMulti={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </Container>
    </div>
  );
}

export default CreateProductDiscount;
